import React, { useState } from "react";

export const CopyRegular = ({
  isDarkMode,
  size = 20,
  ...props
}: { isDarkMode?: boolean; size?: number } & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.5 2C6.67157 2 6 2.67157 6 3.5V13.5C6 14.3284 6.67157 15 7.5 15H15.5C16.3284 15 17 14.3284 17 13.5V3.5C17 2.67157 16.3284 2 15.5 2H7.5ZM7 3.5C7 3.22386 7.22386 3 7.5 3H15.5C15.7761 3 16 3.22386 16 3.5V13.5C16 13.7761 15.7761 14 15.5 14H7.5C7.22386 14 7 13.7761 7 13.5V3.5ZM4.5 5C3.67157 5 3 5.67157 3 6.5V16.5C3 17.3284 3.67157 18 4.5 18H12.5C13.3284 18 14 17.3284 14 16.5V16H13V16.5C13 16.7761 12.7761 17 12.5 17H4.5C4.22386 17 4 16.7761 4 16.5V6.5C4 6.22386 4.22386 6 4.5 6H5V5H4.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const EditRegular = ({
  isDarkMode,
  size = 20,
  ...props
}: { isDarkMode?: boolean; size?: number } & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.1303 2.8504C14.5209 2.45988 15.154 2.45988 15.5446 2.8504L17.1396 4.44543C17.5301 4.83595 17.5301 5.46912 17.1396 5.85964L7.3338 15.6654C7.14622 15.853 6.90159 15.9723 6.63858 16.0093L3.13781 16.5028C2.86811 16.5408 2.62473 16.3577 2.5855 16.0894L3.03058 12.4288C3.06456 12.149 3.19018 11.8906 3.38927 11.6915L14.1303 2.8504ZM14.8374 3.55751L4.09638 12.3986C4.03002 12.465 3.98815 12.5511 3.97682 12.6444L3.63346 15.4746L6.34771 15.092L6.43538 15.0197L17.1765 6.17857L14.8374 3.55751ZM15.5445 4.26462L16.4325 5.15264L15.1956 6.38951L14.3076 5.50149L15.5445 4.26462Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const Briefcase = ({ isDarkMode, color, isActive }: { isDarkMode?: boolean; color?: string; isActive?: boolean }) => {
  let fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.1885 2.20874C12.9059 2.20882 13.534 2.53374 13.9688 2.96851C14.4035 3.4033 14.7284 4.0314 14.7285 4.74878V4.83472H15.6895C16.4067 4.83488 17.035 5.15886 17.4697 5.59351C17.9045 6.02835 18.2295 6.65727 18.2295 7.37476V15.2507C18.2294 16.6558 17.0343 17.7914 15.6895 17.7917H4.31152C2.92271 17.7916 1.77155 16.6396 1.77148 15.2507V7.37476C1.77148 6.02969 2.90632 4.83486 4.31152 4.83472H5.27246V4.74878C5.27261 3.40374 6.40727 2.20874 7.8125 2.20874H12.1885ZM2.99902 15.2507C2.99908 15.9173 3.52777 16.4886 4.17969 16.5574L4.31152 16.5642H15.6895C16.3304 16.5639 16.9227 16.0345 16.9941 15.3826L17.002 15.2507V11.3132H11.751V12.6257L11.7412 12.7146C11.7029 12.8876 11.5563 13.0202 11.3945 13.0544L11.3135 13.0632H8.6875L8.59863 13.0544C8.42557 13.0203 8.29301 12.8876 8.25879 12.7146L8.25 12.6257V11.3132H2.99902V15.2507ZM4.17969 6.06909C3.52775 6.14079 2.99902 6.73382 2.99902 7.37476V10.4373H17.002V7.37476C17.002 6.73379 16.4489 6.14075 15.8164 6.06909L15.6895 6.06226H14.6758V6.06421H5.40723V6.06226H4.31152L4.17969 6.06909ZM7.8125 3.43628C7.10151 3.43628 6.50015 4.06515 6.5 4.74878V5.01929H13.501V4.74878C13.5008 4.1078 12.9479 3.51459 12.3154 3.44312L12.1885 3.43628H7.8125Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const BriefcaseSearch = ({ isDarkMode, color }: { isDarkMode?: boolean; color?: string }) => {
  let fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 5V3.75C7 2.7835 7.7835 2 8.75 2H11.25C12.2165 2 13 2.7835 13 3.75V5H14.5C15.8807 5 17 6.11929 17 7.5V13.5C17 14.8807 15.8807 16 14.5 16H10.1213L9.12132 15H14.5C15.3284 15 16 14.3284 16 13.5V10.5002C15.5822 10.814 15.0628 11 14.5 11H11V11.5C11 11.7761 10.7761 12 10.5 12H9.5C9.22386 12 9 11.7761 9 11.5V11H8.74394C8.6181 10.644 8.44873 10.3085 8.24223 10H9V9.5C9 9.22386 9.22386 9 9.5 9H10.5C10.7761 9 11 9.22386 11 9.5V10H14.5C15.3284 10 16 9.32843 16 8.5V7.5C16 6.67157 15.3284 6 14.5 6H5.5C4.67157 6 4 6.67157 4 7.5V8.02746C3.65327 8.06579 3.31841 8.14352 3 8.25606V7.5C3 6.11929 4.11929 5 5.5 5H7ZM8 3.75V5H12V3.75C12 3.33579 11.6642 3 11.25 3H8.75C8.33579 3 8 3.33579 8 3.75ZM4.5 16C5.2862 16 6.01185 15.7408 6.59615 15.3031L9.14644 17.8535C9.3417 18.0488 9.65828 18.0488 9.85355 17.8535C10.0488 17.6583 10.0488 17.3417 9.85356 17.1464L7.30324 14.596C7.74082 14.0117 8 13.2861 8 12.5C8 10.567 6.433 9 4.5 9C2.567 9 1 10.567 1 12.5C1 14.433 2.567 16 4.5 16ZM4.5 15C3.11929 15 2 13.8807 2 12.5C2 11.1193 3.11929 10 4.5 10C5.88071 10 7 11.1193 7 12.5C7 13.8807 5.88071 15 4.5 15Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MapSearchIcon = ({ isDarkMode, color }: { isDarkMode?: boolean; color?: string }) => {
  let fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.21289 3.08936C7.38497 2.96902 7.61503 2.96902 7.78711 3.08936L12.5 6.38916L17.2129 3.08936C17.3655 2.98264 17.5652 2.97031 17.7305 3.05615C17.8957 3.14219 17.9999 3.31323 18 3.49951V13.4995C18 13.6416 17.9378 13.774 17.835 13.8677C17.8542 13.6943 17.8652 13.4993 17.8652 13.2778C17.8652 12.3711 17.5376 11.5304 17 10.8384V4.45947L13 7.25928V9.00928C12.6539 9.03146 12.3189 9.09419 12 9.19385V7.25928L8 4.45947V13.4487C8.08468 13.4797 8.16799 13.5183 8.24805 13.5649L9.06445 14.0181C9.15488 14.5363 9.33861 15.0223 9.59766 15.4585L7.74609 14.4302C7.58407 14.3349 7.41058 14.3366 7.25781 14.4282L7.24316 14.436L2.74316 16.936C2.5883 17.0221 2.39878 17.02 2.24609 16.9302C2.09373 16.8403 2.00006 16.6764 2 16.4995V6.99951C2.00013 6.83654 2.07938 6.68285 2.21289 6.58936L7.21289 3.08936ZM3 7.25928V15.6499L6.75098 13.5659C6.83165 13.5182 6.91511 13.4789 7 13.4478V4.45947L3 7.25928Z"
        fill={fillColor}
      />
      <path
        d="M16.3032 15.5961C16.7408 15.0118 17 14.2862 17 13.5C17 11.567 15.433 10 13.5 10C11.567 10 10 11.567 10 13.5C10 15.433 11.567 17 13.5 17C14.2862 17 15.0118 16.7408 15.5961 16.3032L18.1464 18.8536C18.3417 19.0489 18.6583 19.0489 18.8535 18.8536C19.0488 18.6584 19.0488 18.3418 18.8536 18.1465L16.3032 15.5961ZM16 13.5C16 14.8807 14.8807 16 13.5 16C12.1193 16 11 14.8807 11 13.5C11 12.1193 12.1193 11 13.5 11C14.8807 11 16 12.1193 16 13.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const BriefcaseFilled = ({ isDarkMode, color }: { isDarkMode?: boolean; color?: string }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 5V3.75C7 2.7835 7.7835 2 8.75 2H11.25C12.2165 2 13 2.7835 13 3.75V5H14.5C15.8807 5 17 6.11929 17 7.5V8.5C17 9.32843 16.3284 10 15.5 10H11V9.5C11 9.22386 10.7761 9 10.5 9H9.5C9.22386 9 9 9.22386 9 9.5V10H4.5C3.67157 10 3 9.32843 3 8.5V7.5C3 6.11929 4.11929 5 5.5 5H7ZM8 5H12V3.75C12 3.33579 11.6642 3 11.25 3H8.75C8.33579 3 8 3.33579 8 3.75V5ZM3 10.5002V13.5C3 14.8807 4.11929 16 5.5 16H14.5C15.8807 16 17 14.8807 17 13.5V10.5002C16.5822 10.814 16.0628 11 15.5 11H11V11.5C11 11.7761 10.7761 12 10.5 12H9.5C9.22386 12 9 11.7761 9 11.5V11H4.5C3.9372 11 3.41783 10.814 3 10.5002Z"
        fill={color || (isDarkMode ? "#ffff" : "none")}
      />
    </svg>
  );
};

export const ArrowLeftRegular = ({ isDarkMode, isActive }: { isDarkMode?: boolean; isActive?: boolean }) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.15898 16.3666C9.36292 16.5528 9.67918 16.5384 9.86536 16.3345C10.0515 16.1305 10.0371 15.8143 9.8332 15.6281L3.66535 9.99736H17.4961C17.7722 9.99736 17.9961 9.7735 17.9961 9.49736C17.9961 9.22122 17.7722 8.99736 17.4961 8.99736H3.66824L9.8332 3.36927C10.0371 3.18309 10.0515 2.86684 9.86536 2.66289C9.67918 2.45895 9.36292 2.44456 9.15898 2.63074L2.24263 8.94478C2.10268 9.07254 2.02285 9.24008 2.00314 9.41323C1.99851 9.44058 1.99609 9.46869 1.99609 9.49736C1.99609 9.52423 1.99821 9.55061 2.00229 9.57633C2.02047 9.75224 2.10058 9.9229 2.24263 10.0526L9.15898 16.3666Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ArrowLeftFilled = ({ isDarkMode, isActive }: { isDarkMode?: boolean; isActive?: boolean }) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.73073 16.7949C9.03167 17.0795 9.50636 17.0663 9.79098 16.7654C10.0756 16.4644 10.0624 15.9897 9.76145 15.7051L4.52241 10.75H17.2461C17.6603 10.75 17.9961 10.4142 17.9961 10C17.9961 9.5858 17.6603 9.25001 17.2461 9.25001H4.52014L9.76145 4.29275C10.0624 4.00813 10.0756 3.53344 9.79098 3.23251C9.50636 2.93157 9.03167 2.91835 8.73073 3.20298L2.31351 9.27242C2.14721 9.4297 2.04721 9.62981 2.01351 9.8386C2.0021 9.89059 1.99609 9.9446 1.99609 10C1.99609 10.0576 2.00259 10.1137 2.01488 10.1676C2.04986 10.3733 2.14941 10.5703 2.31351 10.7255L8.73073 16.7949Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CityRegular = ({ isDarkMode, color }: { isDarkMode?: boolean; color?: string }) => {
  let fillColor = isDarkMode ? "#479ef5" : "#0f6cbd";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.75 2.74609C12.75 2.33188 12.4142 1.99609 12 1.99609C11.5858 1.99609 11.25 2.33188 11.25 2.74609V3.99939H9.25C8.2835 3.99939 7.5 4.78289 7.5 5.74939V7.90378C9.01944 7.76609 10.5 8.93997 10.5 10.6474V21.2494C10.5 21.2755 10.4994 21.3015 10.4983 21.3274V21.9994H13.4983V20.7494H13.5V13.2494C13.5 11.7306 14.7312 10.4994 16.25 10.4994H16.5V5.74939C16.5 4.78289 15.7165 3.99939 14.75 3.99939H12.75V2.74609ZM14.4983 21.9994H18.75C19.7165 21.9994 20.5 21.2159 20.5 20.2494V13.2494C20.5 12.2829 19.7165 11.4994 18.75 11.4994H16.25C15.2835 11.4994 14.5 12.2829 14.5 13.2494V20.7494H14.4983V21.9994ZM9.5 20.7494H9.49829V21.3004L9.4982 21.3018V21.9994H8.75541L8.75 21.9994H5.25C4.2835 21.9994 3.5 21.2159 3.5 20.2494V12.289C3.5 11.6996 3.79674 11.1498 4.28945 10.8262L6.78945 9.18462C7.95318 8.42047 9.5 9.25524 9.5 10.6474V20.7494Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const WarningRegular = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0297 3.65893C10.8859 2.1111 13.1111 2.11108 13.9673 3.65888L21.7131 17.6603C22.5427 19.16 21.4581 20.9995 19.7443 20.9995H4.25323C2.53945 20.9995 1.45483 19.16 2.28438 17.6604L10.0297 3.65893ZM12.9973 17.0009C12.9973 16.4494 12.5502 16.0022 11.9987 16.0022C11.4471 16.0022 11 16.4494 11 17.0009C11 17.5524 11.4471 17.9996 11.9987 17.9996C12.5502 17.9996 12.9973 17.5524 12.9973 17.0009ZM12.7381 9.14764C12.6882 8.7816 12.3742 8.4997 11.9945 8.5C11.5802 8.50033 11.2447 8.83639 11.2451 9.2506L11.2487 13.7522L11.2556 13.854C11.3055 14.22 11.6196 14.5019 11.9993 14.5016C12.4135 14.5013 12.749 14.1652 12.7487 13.751L12.7451 9.2494L12.7381 9.14764Z"
        fill="#F7630C"
      />
    </svg>
  );
};

export const MailArrowForwardRegular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.7059 14.875C18.2702 14.875 19.7049 14.3147 20.8236 13.382V19.0312C20.8236 20.6708 19.5068 22 17.8824 22H4.94127C3.3169 22 2 20.6708 2 19.0312V10.5679L11.1136 15.9805C11.2977 16.0898 11.526 16.0898 11.7101 15.9805L14.3339 14.4222C15.0684 14.7145 15.8686 14.875 16.7059 14.875ZM4.94127 6.5625H10.4789C10.3202 7.12874 10.2353 7.72624 10.2353 8.34375C10.2353 10.6068 11.3756 12.601 13.1078 13.7729L11.4119 14.7799L2.01795 9.20223C2.18014 7.71747 3.42708 6.5625 4.94127 6.5625ZM11.4118 8.34375C11.4118 11.295 13.782 13.6875 16.7059 13.6875C19.6297 13.6875 22 11.295 22 8.34375C22 5.39248 19.6297 3 16.7059 3C13.782 3 11.4118 5.39248 11.4118 8.34375ZM17.7605 5.25203C17.9902 5.02016 18.3627 5.02016 18.5924 5.25203L20.6512 7.33016C20.7076 7.38708 20.7502 7.45269 20.7789 7.52272C20.8077 7.59273 20.8235 7.66949 20.8235 7.75C20.8235 7.83051 20.8077 7.90727 20.7789 7.97728C20.7506 8.04627 20.7089 8.11098 20.6537 8.16732L18.5924 10.248C18.3627 10.4798 17.9902 10.4798 17.7605 10.248C17.5308 10.0161 17.5308 9.64015 17.7605 9.40828L18.8152 8.34375H17C15.8629 8.34375 14.9412 9.27416 14.9412 10.4219V10.7188C14.9412 11.0467 14.6778 11.3125 14.3529 11.3125C14.0281 11.3125 13.7647 11.0467 13.7647 10.7188V10.4219C13.7647 8.61832 15.2132 7.15625 17 7.15625H18.8152L17.7605 6.09172C17.5308 5.85985 17.5308 5.4839 17.7605 5.25203Z"
        fill={isDarkMode ? "#479ef5" : "#0f6cbd"}
      />
    </svg>
  );
};

export const ArrowSyncCircleRegular = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3ZM18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10ZM10.0001 7.5C11.0245 7.5 11.9062 8.11648 12.2922 9H11.4999C11.2237 9 10.9999 9.22386 10.9999 9.5C10.9999 9.77614 11.2237 10 11.4999 10H13.4999C13.776 10 13.9999 9.77614 13.9999 9.5V7.5C13.9999 7.22386 13.776 7 13.4999 7C13.2237 7 12.9999 7.22386 12.9999 7.5V8.19617C12.3877 7.18015 11.2737 6.5 10.0001 6.5C8.96342 6.5 8.03154 6.9513 7.39138 7.66654C7.20721 7.87231 7.22473 8.1884 7.43049 8.37257C7.63625 8.55673 7.95235 8.53922 8.13651 8.33346C8.59499 7.8212 9.25968 7.5 10.0001 7.5ZM7.00012 11.8037V12.5C7.00012 12.7761 6.77626 13 6.50012 13C6.22398 13 6.00012 12.7761 6.00012 12.5V10.5C6.00012 10.2239 6.22398 10 6.50012 10H8.50012C8.77626 10 9.00012 10.2239 9.00012 10.5C9.00012 10.7761 8.77626 11 8.50012 11H7.70793C8.09394 11.8835 8.97557 12.5 10.0001 12.5C10.7404 12.5 11.4051 12.1788 11.8636 11.6665C12.0478 11.4608 12.3639 11.4433 12.5696 11.6274C12.7754 11.8116 12.7929 12.1277 12.6087 12.3335C11.9686 13.0487 11.0367 13.5 10.0001 13.5C8.7263 13.5 7.61231 12.8198 7.00012 11.8037Z"
        fill={isDarkMode ? "#479ef5" : "#0f6cbd"}
      />
    </svg>
  );
};

export const TagRegular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.0055 4.03302C18.0039 2.93471 17.1169 2.04321 16.0186 2.03601L11.1282 2.00395C10.5942 2.00045 10.0809 2.21071 9.70272 2.58789L3.02118 9.25243C2.23844 10.0332 2.23763 11.3009 3.01938 12.0827L7.96778 17.0311C8.74882 17.8121 10.0152 17.8121 10.7962 17.0311L17.427 10.4002C17.8028 10.0244 18.0136 9.51453 18.0128 8.98308L18.0055 4.03302ZM13.999 6.99985C13.4467 6.99985 12.999 6.55213 12.999 5.99985C12.999 5.44756 13.4467 4.99985 13.999 4.99985C14.5513 4.99985 14.999 5.44756 14.999 5.99985C14.999 6.55213 14.5513 6.99985 13.999 6.99985Z"
        fill={isDarkMode ? "#479ef5" : "#0f6cbd"}
      />
    </svg>
  );
};

export const ChevronDoubleLeft16Regular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.35355 12.1464C8.54882 12.3417 8.54882 12.6583 8.35355 12.8536C8.15829 13.0488 7.84171 13.0488 7.64645 12.8536L3.14645 8.35355C2.95118 8.15829 2.95118 7.84171 3.14645 7.64645L7.64645 3.14645C7.84171 2.95118 8.15829 2.95118 8.35355 3.14645C8.54882 3.34171 8.54882 3.65829 8.35355 3.85355L4.20711 8L8.35355 12.1464ZM12.3536 12.1464C12.5488 12.3417 12.5488 12.6583 12.3536 12.8536C12.1583 13.0488 11.8417 13.0488 11.6464 12.8536L7.14645 8.35355C6.95118 8.15829 6.95118 7.84171 7.14645 7.64645L11.6464 3.14645C11.8417 2.95118 12.1583 2.95118 12.3536 3.14645C12.5488 3.34171 12.5488 3.65829 12.3536 3.85355L8.20711 8L12.3536 12.1464Z"
        fill={isDarkMode ? "#ffffff" : "#424242"}
      />
    </svg>
  );
};

export const ChevronDoubleRight16Regular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.64645 3.85355C7.45118 3.65829 7.45118 3.34171 7.64645 3.14645C7.84171 2.95118 8.15829 2.95118 8.35355 3.14645L12.8536 7.64645C13.0488 7.84171 13.0488 8.15829 12.8536 8.35355L8.35355 12.8536C8.15829 13.0488 7.84171 13.0488 7.64645 12.8536C7.45118 12.6583 7.45118 12.3417 7.64645 12.1464L11.7929 8L7.64645 3.85355ZM3.64645 3.85355C3.45118 3.65829 3.45118 3.34171 3.64645 3.14645C3.84171 2.95118 4.15829 2.95118 4.35355 3.14645L8.85355 7.64645C9.04882 7.84171 9.04882 8.15829 8.85355 8.35355L4.35355 12.8536C4.15829 13.0488 3.84171 13.0488 3.64645 12.8536C3.45118 12.6583 3.45118 12.3417 3.64645 12.1464L7.79289 8L3.64645 3.85355Z"
        fill={isDarkMode ? "#ffffff" : "#424242"}
      />
    </svg>
  );
};

export const ChevronLeft16Regular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3536 3.14645C10.5488 3.34171 10.5488 3.65829 10.3536 3.85355L6.20711 8L10.3536 12.1464C10.5488 12.3417 10.5488 12.6583 10.3536 12.8536C10.1583 13.0488 9.84171 13.0488 9.64645 12.8536L5.14645 8.35355C4.95118 8.15829 4.95118 7.84171 5.14645 7.64645L9.64645 3.14645C9.84171 2.95118 10.1583 2.95118 10.3536 3.14645Z"
        fill={isDarkMode ? "#ffffff" : "#424242"}
      />
    </svg>
  );
};

export const ChevronRight16Regular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.64645 3.14645C5.45118 3.34171 5.45118 3.65829 5.64645 3.85355L9.79289 8L5.64645 12.1464C5.45118 12.3417 5.45118 12.6583 5.64645 12.8536C5.84171 13.0488 6.15829 13.0488 6.35355 12.8536L10.8536 8.35355C11.0488 8.15829 11.0488 7.84171 10.8536 7.64645L6.35355 3.14645C6.15829 2.95118 5.84171 2.95118 5.64645 3.14645Z"
        fill={isDarkMode ? "#ffffff" : "#424242"}
      />
    </svg>
  );
};

export const IconAIAgent = ({ isDarkMode, isActive }: { isDarkMode?: boolean; isActive?: boolean }) => {
  const [isHovered, setIsHovered] = useState(false);

  const fillColor = isActive || isHovered ? (isDarkMode ? "#479ef5" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M17 12.2764V10.4003C17.3578 10.2174 17.6929 9.99647 18 9.74284V12.2764C18 13.6935 16.8359 14.8423 15.4 14.8423H10.81L6.79895 17.8034C6.35668 18.1298 5.73 18.0406 5.39921 17.6042C5.26989 17.4335 5.2 17.2262 5.2 17.0133L5.19937 14.8423H4.6C3.16406 14.8423 2 13.6935 2 12.2764V5.56582C2 4.14876 3.16406 3 4.6 3H9.59971C9.43777 3.31679 9.30564 3.65136 9.20703 4H4.6C3.70383 4 3 4.71348 3 5.56582V12.2764C3 13.1288 3.70383 13.8423 4.6 13.8423H6.19908L6.2 17L6.20346 16.9997L6.20502 16.9988L10.4809 13.8423H15.4C16.2962 13.8423 17 13.1288 17 12.2764Z"
        fill={fillColor}
      />
      <path
        d="M13.7565 2.23004L13.4469 1.25659C13.421 1.18156 13.3729 1.11659 13.3094 1.07064C13.2458 1.02468 13.1699 1 13.0921 1C13.0142 1 12.9383 1.02468 12.8747 1.07064C12.8112 1.11659 12.7631 1.18156 12.7372 1.25659L12.4277 2.23004C12.3333 2.52392 12.1737 2.7915 11.9614 3.01188C11.749 3.23226 11.4897 3.39946 11.2036 3.5004L10.2511 3.81677C10.1777 3.84324 10.1141 3.89233 10.0691 3.95728C10.0241 4.02222 10 4.09982 10 4.17939C10 4.25895 10.0241 4.33655 10.0691 4.40149C10.1141 4.46644 10.1777 4.51553 10.2511 4.542L11.2036 4.85837C11.4482 4.94171 11.6738 5.07331 11.8679 5.2452C11.9041 5.27723 11.9391 5.31066 11.973 5.34544C12.1513 5.52832 12.293 5.74429 12.3908 5.9812C12.4114 6.03111 12.4301 6.08194 12.4467 6.13359L12.7563 7.10704C12.7796 7.17467 12.821 7.23413 12.8754 7.27886C12.8814 7.28375 12.8875 7.28847 12.8938 7.293C12.9573 7.33896 13.0333 7.36364 13.1111 7.36364C13.189 7.36364 13.2649 7.33896 13.3284 7.293C13.392 7.24704 13.44 7.18207 13.4659 7.10704L13.7755 6.13359C13.8718 5.83764 14.0343 5.56872 14.2501 5.34819C14.4658 5.12767 14.729 4.96161 15.0186 4.86323L15.9711 4.54686C16.0446 4.52039 16.1081 4.4713 16.1531 4.40636C16.1981 4.34141 16.2222 4.26381 16.2222 4.18425C16.2222 4.10469 16.1981 4.02709 16.1531 3.96215C16.1081 3.8972 16.0446 3.84811 15.9711 3.82164L15.9521 3.81677L14.9995 3.5004C14.7099 3.40202 14.4468 3.23597 14.231 3.01544C14.0152 2.79492 13.8527 2.52599 13.7565 2.23004ZM17.1267 8.24055L17.807 8.46653L17.8207 8.47C17.8731 8.48891 17.9185 8.52397 17.9506 8.57036C17.9828 8.61675 18 8.67218 18 8.72901C18 8.78584 17.9828 8.84127 17.9506 8.88766C17.9185 8.93405 17.8731 8.96911 17.8207 8.98802L17.1403 9.214C16.9334 9.28427 16.7454 9.40288 16.5913 9.5604C16.4372 9.71792 16.3211 9.91 16.2524 10.1214L16.0312 10.8167C16.0127 10.8703 15.9784 10.9167 15.933 10.9495C15.8876 10.9824 15.8334 11 15.7778 11C15.7222 11 15.6679 10.9824 15.6225 10.9495C15.5771 10.9167 15.5428 10.8703 15.5243 10.8167L15.3032 10.1214C15.2349 9.90936 15.119 9.71658 14.9649 9.55843C14.8107 9.40028 14.6225 9.28114 14.4153 9.21052L13.7349 8.98454C13.6825 8.96564 13.637 8.93057 13.6049 8.88418C13.5728 8.83779 13.5556 8.78236 13.5556 8.72553C13.5556 8.66871 13.5728 8.61328 13.6049 8.56689C13.637 8.5205 13.6825 8.48543 13.7349 8.46653L14.4153 8.24055C14.6196 8.16844 14.8049 8.04902 14.9565 7.8916C15.1082 7.73419 15.2222 7.54306 15.2896 7.33315L15.5107 6.63783C15.5292 6.58423 15.5635 6.53783 15.6089 6.505C15.6543 6.47217 15.7086 6.45455 15.7642 6.45455C15.8198 6.45455 15.874 6.47217 15.9194 6.505C15.9648 6.53783 15.9991 6.58423 16.0176 6.63783L16.2387 7.33315C16.3075 7.54454 16.4236 7.73663 16.5777 7.89415C16.7318 8.05167 16.9198 8.17028 17.1267 8.24055Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ComposeRegular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.8536 2.85355C18.0488 2.65829 18.0488 2.34171 17.8536 2.14645C17.6583 1.95118 17.3417 1.95118 17.1465 2.14645L9.14648 10.1464L9 11L9.85359 10.8536L17.8536 2.85355ZM5.5 2.99997C4.11929 2.99997 3 4.11926 3 5.49997V14.5C3 15.8807 4.11929 17 5.5 17H14.5C15.8807 17 17 15.8807 17 14.5V8.49997C17 8.22383 16.7761 7.99997 16.5 7.99997C16.2239 7.99997 16 8.22383 16 8.49997V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V5.49997C4 4.67154 4.67157 3.99997 5.5 3.99997H11.5046C11.7807 3.99997 12.0046 3.77611 12.0046 3.49997C12.0046 3.22383 11.7807 2.99997 11.5046 2.99997H5.5Z"
        fill={isDarkMode ? "#242424" : "#ffffff"}
      />
    </svg>
  );
};

export const MoreHorizontalRegular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.25 10C6.25 10.6904 5.69036 11.25 5 11.25C4.30964 11.25 3.75 10.6904 3.75 10C3.75 9.30964 4.30964 8.75 5 8.75C5.69036 8.75 6.25 9.30964 6.25 10ZM11.25 10C11.25 10.6904 10.6904 11.25 10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75C10.6904 8.75 11.25 9.30964 11.25 10ZM15 11.25C15.6904 11.25 16.25 10.6904 16.25 10C16.25 9.30964 15.6904 8.75 15 8.75C14.3096 8.75 13.75 9.30964 13.75 10C13.75 10.6904 14.3096 11.25 15 11.25Z"
        fill={isDarkMode ? "#ffffff" : "#424242"}
      />
    </svg>
  );
};

export const PersonIcon = ({
  isDarkMode,
  size = 20,
  isActive = false,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#479ef5" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2C7.79086 2 6 3.79086 6 6C6 8.20914 7.79086 10 10 10C12.2091 10 14 8.20914 14 6C14 3.79086 12.2091 2 10 2ZM7 6C7 4.34315 8.34315 3 10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6ZM5.00873 11C3.90315 11 3 11.8869 3 13C3 14.6912 3.83281 15.9663 5.13499 16.7966C6.41697 17.614 8.14526 18 10 18C11.8547 18 13.583 17.614 14.865 16.7966C16.1672 15.9663 17 14.6912 17 13C17 11.8956 16.1045 11 15 11L5.00873 11ZM4 13C4 12.4467 4.44786 12 5.00873 12L15 12C15.5522 12 16 12.4478 16 13C16 14.3088 15.3777 15.2837 14.3274 15.9534C13.2568 16.636 11.7351 17 10 17C8.26489 17 6.74318 16.636 5.67262 15.9534C4.62226 15.2837 4 14.3088 4 13Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AddRegular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2.5C10 2.22386 9.77614 2 9.5 2C9.22386 2 9 2.22386 9 2.5V9H2.5C2.22386 9 2 9.22386 2 9.5C2 9.77614 2.22386 10 2.5 10H9V16.5C9 16.7761 9.22386 17 9.5 17C9.77614 17 10 16.7761 10 16.5V10H16.5C16.7761 10 17 9.77614 17 9.5C17 9.22386 16.7761 9 16.5 9H10V2.5Z"
        fill={isDarkMode ? "#ffffff" : "#424242"}
      />
    </svg>
  );
};

export const ArrowUpRegular = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.13074 9.16094C2.94456 9.36488 2.95895 9.68113 3.16289 9.86731C3.36683 10.0535 3.68309 10.0391 3.86927 9.83515L9.5 3.6673L9.5 17.498C9.5 17.7742 9.72386 17.998 10 17.998C10.2761 17.998 10.5 17.7742 10.5 17.498L10.5 3.67019L16.1281 9.83515C16.3143 10.0391 16.6305 10.0535 16.8345 9.86731C17.0384 9.68113 17.0528 9.36488 16.8666 9.16094L10.5526 2.24458C10.4248 2.10464 10.2573 2.02481 10.0841 2.0051C10.0568 2.00046 10.0287 1.99805 10 1.99805C9.97313 1.99805 9.94675 2.00017 9.92103 2.00425C9.74512 2.02242 9.57446 2.10253 9.44478 2.24458L3.13074 9.16094Z"
        fill={isDarkMode ? "#ffffff" : "#424242"}
      />
    </svg>
  );
};

export const LocationIcon = ({
  isDarkMode,
  size = 20,
  isActive = false,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#479ef5" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 9C13 10.6569 11.6569 12 10 12C8.34315 12 7 10.6569 7 9C7 7.34315 8.34315 6 10 6C11.6569 6 13 7.34315 13 9ZM12 9C12 7.89543 11.1046 7 10 7C8.89543 7 8 7.89543 8 9C8 10.1046 8.89543 11 10 11C11.1046 11 12 10.1046 12 9ZM14.9497 13.955C17.6834 11.2201 17.6834 6.78601 14.9497 4.05115C12.2161 1.31628 7.78392 1.31628 5.05025 4.05115C2.31658 6.78601 2.31658 11.2201 5.05025 13.955L6.57128 15.4538L8.61408 17.4389L8.74691 17.5567C9.52168 18.1847 10.6562 18.1455 11.3861 17.4391L13.8223 15.0691L14.9497 13.955ZM5.75499 4.75619C8.09944 2.41072 11.9006 2.41072 14.245 4.75619C16.5294 7.04153 16.5879 10.7104 14.4207 13.0667L14.245 13.2499L12.9237 14.5539L10.6931 16.7225L10.6002 16.8021C10.2459 17.0699 9.7543 17.0698 9.40012 16.802L9.30713 16.7224L6.3263 13.817L5.75499 13.2499L5.57927 13.0667C3.41208 10.7104 3.47065 7.04153 5.75499 4.75619Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const LocationIconFilled = ({
  isDarkMode,
  size = 20,
  isActive = false,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#479ef5" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.05024 4.0508C7.78391 1.31656 12.2161 1.31624 14.9496 4.0508C17.6831 6.78556 17.6829 11.2202 14.9496 13.9551L13.8217 15.0693L11.3861 17.4394C10.6563 18.1458 9.52127 18.1845 8.74651 17.5566L8.6137 17.4394L6.57074 15.4541L5.05024 13.9551C2.31659 11.2202 2.31659 6.78565 5.05024 4.0508ZM9.99944 6.50001C8.61886 6.50012 7.49951 7.61941 7.49945 9C7.49945 10.3806 8.61883 11.4999 9.99944 11.5C11.38 11.4998 12.4994 10.3806 12.4994 9C12.4994 7.61944 11.38 6.50017 9.99944 6.50001Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CheckmarkIcon = ({ isDarkMode }: { isDarkMode?: boolean }) => {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4971 3.67085C11.7249 3.89866 11.7249 4.26801 11.4971 4.49581L6.24711 9.74581C6.01931 9.97362 5.64996 9.97362 5.42216 9.74581L3.08882 7.41248C2.86102 7.18467 2.86102 6.81533 3.08882 6.58752C3.31663 6.35972 3.68598 6.35972 3.91378 6.58752L5.83464 8.50838L10.6722 3.67085C10.9 3.44305 11.2693 3.44305 11.4971 3.67085Z"
        fill={isDarkMode ? "#424242" : "#ffffff"}
      />
    </svg>
  );
};

export const ArrowLeftBold = ({
  isDarkMode,
  isActive,
  isDisabled,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M8.73073 16.7951C9.03167 17.0797 9.50636 17.0665 9.79098 16.7656C10.0756 16.4646 10.0624 15.9899 9.76145 15.7053L4.52241 10.7502H17.2461C17.6603 10.7502 17.9961 10.4144 17.9961 10.0002C17.9961 9.58598 17.6603 9.25019 17.2461 9.25019H4.52014L9.76145 4.29294C10.0624 4.00831 10.0756 3.53362 9.79098 3.23269C9.50636 2.93175 9.03167 2.91853 8.73073 3.20316L2.31351 9.2726C2.14721 9.42989 2.04721 9.63 2.01351 9.83879C2.0021 9.89077 1.99609 9.94478 1.99609 10.0002C1.99609 10.0578 2.00259 10.1139 2.01488 10.1677C2.04986 10.3735 2.14941 10.5704 2.31351 10.7256L8.73073 16.7951Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MagnifyingGlass = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
  color,
  ...props
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
  color?: string;
} & React.SVGProps<SVGSVGElement>) => {
  const [isHovered, setIsHovered] = useState(false);

  let fillColor = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (isDisabled) {
    fillColor = "#424242";
  }
  if (color) {
    fillColor = color;
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
      {...props}
    >
      <path
        d="M9.30887 10.016C8.53903 10.6318 7.56252 11 6.5 11C4.01472 11 2 8.98531 2 6.50002C2 4.01473 4.01472 2 6.5 2C8.98528 2 11 4.01473 11 6.50002C11 7.56252 10.6318 8.53901 10.016 9.30885L13.8536 13.1464C14.0488 13.3417 14.0488 13.6583 13.8536 13.8536C13.6583 14.0488 13.3417 14.0488 13.1464 13.8536L9.30887 10.016ZM10 6.50002C10 4.56701 8.433 3 6.5 3C4.567 3 3 4.56701 3 6.50002C3 8.43302 4.567 10 6.5 10C8.433 10 10 8.43302 10 6.50002Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const StarIcon = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M9.10433 2.89874C9.47114 2.15549 10.531 2.1555 10.8978 2.89874L12.8282 6.81024L17.1448 7.43748C17.9651 7.55666 18.2926 8.56464 17.699 9.14317L14.5755 12.1878L15.3129 16.487C15.453 17.3039 14.5956 17.9269 13.8619 17.5412L10.0011 15.5114L6.14018 17.5412C5.40655 17.9269 4.54913 17.3039 4.68924 16.487L5.4266 12.1878L2.30308 9.14317C1.70956 8.56463 2.03708 7.55666 2.8573 7.43748L7.17389 6.81024L9.10433 2.89874ZM10.0011 3.34131L8.07062 7.25281C7.92496 7.54795 7.6434 7.75252 7.31769 7.79985L3.00109 8.42709L6.12461 11.4718C6.3603 11.7015 6.46784 12.0325 6.41221 12.3569L5.67484 16.656L9.53572 14.6263C9.82705 14.4731 10.1751 14.4731 10.4664 14.6263L14.3273 16.656L13.5899 12.3569C13.5343 12.0325 13.6418 11.7015 13.8775 11.4718L17.001 8.42709L12.6844 7.79985C12.3587 7.75252 12.0772 7.54795 11.9315 7.25281L10.0011 3.34131Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const PeopleSearchIcon = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M8.00078 1.6001C6.23347 1.6001 4.80078 3.03279 4.80078 4.8001C4.80078 6.56741 6.23347 8.0001 8.00078 8.0001C9.76809 8.0001 11.2008 6.56741 11.2008 4.8001C11.2008 3.03279 9.76809 1.6001 8.00078 1.6001ZM5.60078 4.8001C5.60078 3.47461 6.6753 2.4001 8.00078 2.4001C9.32627 2.4001 10.4008 3.47461 10.4008 4.8001C10.4008 6.12558 9.32627 7.2001 8.00078 7.2001C6.6753 7.2001 5.60078 6.12558 5.60078 4.8001ZM11.8928 13.4374C11.0358 13.9838 9.92953 14.2892 8.72324 14.3749C8.66488 14.2206 8.57357 14.0758 8.44931 13.9516L8.09737 13.5996C9.44531 13.5864 10.6262 13.2962 11.4627 12.7628C12.303 12.227 12.8008 11.4471 12.8008 10.4001C12.8008 9.95836 12.4425 9.6001 12.0008 9.6001L6.99593 9.6001C6.89526 9.31528 6.75977 9.0469 6.59456 8.8001L12.0008 8.8001C12.8844 8.8001 13.6008 9.51655 13.6008 10.4001C13.6008 11.7531 12.9345 12.7731 11.8928 13.4374ZM3.60078 13.6001C4.22974 13.6001 4.81026 13.3927 5.2777 13.0426L7.31793 15.0829C7.47414 15.2391 7.72741 15.2391 7.88362 15.0829C8.03983 14.9267 8.03984 14.6734 7.88363 14.5172L5.84337 12.4769C6.19344 12.0095 6.40078 11.429 6.40078 10.8001C6.40078 9.2537 5.14718 8.0001 3.60078 8.0001C2.05438 8.0001 0.800781 9.2537 0.800781 10.8001C0.800781 12.3465 2.05438 13.6001 3.60078 13.6001ZM3.60078 12.8001C2.49621 12.8001 1.60078 11.9047 1.60078 10.8001C1.60078 9.69553 2.49621 8.8001 3.60078 8.8001C4.70535 8.8001 5.60078 9.69553 5.60078 10.8001C5.60078 11.9047 4.70535 12.8001 3.60078 12.8001Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MapIcon = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M14.1843 2.44511C14.3166 2.51399 14.3996 2.65075 14.3996 2.7999V10.7999C14.3996 10.9404 14.3259 11.0706 14.2054 11.1429L10.2054 13.5429C10.0828 13.6164 9.93032 13.619 9.80535 13.5496L6.19654 11.5447C6.06677 11.4682 5.92795 11.4693 5.8056 11.5428L5.79387 11.5496L2.19387 13.5496C2.06997 13.6184 1.91891 13.6165 1.79676 13.5447C1.67461 13.4728 1.59961 13.3416 1.59961 13.1999V5.5999C1.59961 5.46938 1.66329 5.34706 1.77022 5.27221L5.77022 2.47221C5.90795 2.3758 6.09127 2.3758 6.22899 2.47221L9.99961 5.11164L13.7702 2.47221C13.8924 2.38668 14.052 2.37623 14.1843 2.44511ZM2.39961 5.80817V12.5201L5.4 10.8532C5.46472 10.8149 5.5315 10.7832 5.59961 10.7583V3.56817L2.39961 5.80817ZM6.59787 10.8525L9.60252 12.5217L9.5997 5.80823L6.39961 3.56817V10.7592C6.46743 10.784 6.53376 10.8151 6.59787 10.8525ZM10.4025 12.4917L13.5996 10.5734V3.56817L10.3997 5.8081L10.4025 12.4917Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ResourceIcon = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M10.0332 1.65234C10.6178 1.65234 11.1301 1.91721 11.4844 2.27148C11.8385 2.62571 12.1035 3.13729 12.1035 3.72168V3.79102H12.8857C13.4702 3.79106 13.9817 4.05601 14.3359 4.41016C14.6902 4.76443 14.9551 5.27674 14.9551 5.86133V12.2783C14.9549 13.4231 13.9815 14.3476 12.8857 14.3477H3.61621C2.48478 14.3476 1.54703 13.4097 1.54688 12.2783V5.86133C1.54688 4.76548 2.47136 3.79112 3.61621 3.79102H4.39941V3.72168C4.39952 2.62585 5.32388 1.65234 6.46875 1.65234H10.0332ZM2.54688 12.2783L2.55273 12.3857C2.60508 12.8814 3.01314 13.2895 3.50879 13.3418L3.61621 13.3477H12.8857C13.4078 13.3476 13.8908 12.9168 13.9492 12.3857L13.9551 12.2783V9.06934H9.67676V10.1387C9.67676 10.3392 9.49857 10.4951 9.32031 10.4951H7.18164L7.1084 10.4883C6.96776 10.4603 6.85996 10.3526 6.83203 10.2119L6.8252 10.1387V9.06934H2.54688V12.2783ZM3.61621 4.79102C3.03697 4.79113 2.54688 5.30434 2.54688 5.86133V8.35645H13.9551V5.86133C13.9551 5.33904 13.5046 4.85512 12.9893 4.79688L12.8857 4.79102H12.0596V4.79297H4.50879V4.79102H3.61621ZM6.46875 2.65234C5.88949 2.65234 5.39952 3.16471 5.39941 3.72168V3.94238H11.1035V3.72168C11.1034 3.16471 10.5902 2.65234 10.0332 2.65234H6.46875Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const SettingsIcon = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M12.9135 2.25C13.6475 2.25846 14.3786 2.34326 15.0951 2.50304C15.4078 2.57279 15.6417 2.83351 15.6772 3.15196L15.8474 4.67881C15.9244 5.37986 16.5163 5.91084 17.222 5.91158C17.4117 5.91188 17.5993 5.87238 17.7746 5.79483L19.1752 5.17956C19.4665 5.05159 19.8068 5.12136 20.0243 5.35362C21.0365 6.43464 21.7903 7.73115 22.2291 9.14558C22.3237 9.45058 22.2148 9.78203 21.9577 9.9715L20.7162 10.8866C20.3621 11.1468 20.153 11.56 20.153 11.9995C20.153 12.4389 20.3621 12.8521 20.717 13.1129L21.9596 14.0283C22.2167 14.2177 22.3257 14.5492 22.2311 14.8543C21.7925 16.2685 21.0391 17.5649 20.0275 18.6461C19.8102 18.8783 19.4701 18.9483 19.1789 18.8206L17.7725 18.2045C17.3702 18.0284 16.9081 18.0542 16.5279 18.274C16.1477 18.4937 15.8946 18.8812 15.8463 19.3177L15.6772 20.8444C15.6424 21.1592 15.4135 21.4182 15.1054 21.4915C13.6569 21.8361 12.1478 21.8361 10.6994 21.4915C10.3913 21.4182 10.1624 21.1592 10.1276 20.8444L9.95873 19.32C9.90914 18.8843 9.65571 18.498 9.27579 18.279C8.89588 18.06 8.43457 18.0343 8.03357 18.2094L6.62694 18.8256C6.33559 18.9533 5.9954 18.8833 5.77815 18.6509C4.76599 17.5685 4.01256 16.2705 3.57457 14.8548C3.48023 14.5499 3.58923 14.2186 3.84621 14.0293L5.08955 13.1133C5.44368 12.8531 5.65284 12.4399 5.65284 12.0005C5.65284 11.561 5.44368 11.1478 5.08908 10.8873L3.84653 9.97285C3.58916 9.78345 3.48006 9.45178 3.57473 9.14658C4.01349 7.73215 4.76731 6.43564 5.77949 5.35462C5.99696 5.12236 6.33731 5.05259 6.62861 5.18056L8.02899 5.79572C8.43193 5.97256 8.89517 5.94585 9.27714 5.72269C9.65746 5.50209 9.91065 5.11422 9.95953 4.67764L10.1296 3.15196C10.1651 2.83335 10.3992 2.57254 10.7122 2.50294C11.4294 2.34342 12.1613 2.25865 12.9135 2.25ZM12.9137 3.7499C12.4597 3.75524 12.0069 3.79443 11.5592 3.86702L11.4503 4.84418C11.3484 5.75368 10.8214 6.56102 10.0318 7.01903C9.23734 7.48317 8.26873 7.53903 7.42595 7.16917L6.52766 6.77456C5.95573 7.46873 5.50051 8.25135 5.17989 9.09168L5.97769 9.67879C6.7165 10.2216 7.15284 11.0837 7.15284 12.0005C7.15284 12.9172 6.7165 13.7793 5.97847 14.3215L5.17941 14.9102C5.49975 15.752 5.95504 16.5361 6.52737 17.2316L7.4325 16.8351C8.27059 16.4692 9.23261 16.5227 10.0249 16.9794C10.8172 17.4361 11.3457 18.2417 11.4494 19.1526L11.5583 20.1365C12.448 20.2878 13.3568 20.2878 14.2465 20.1365L14.3554 19.1527C14.4562 18.2421 14.9841 17.4337 15.7773 16.9753C16.5706 16.5168 17.5346 16.463 18.3742 16.8305L19.2786 17.2267C19.8504 16.5323 20.3055 15.7495 20.626 14.909L19.8281 14.3211C19.0893 13.7783 18.653 12.9162 18.653 11.9995C18.653 11.0827 19.0893 10.2206 19.8272 9.67847L20.6241 9.09109C20.3034 8.25061 19.8482 7.46784 19.2761 6.77356L18.3797 7.16737C18.0143 7.32901 17.6191 7.4122 17.22 7.41158C15.7503 7.41004 14.5169 6.30355 14.3565 4.84383L14.2476 3.8667C13.802 3.7942 13.354 3.75512 12.9137 3.7499ZM12.9011 8.24995C14.9721 8.24995 16.6511 9.92888 16.6511 12C16.6511 14.071 14.9721 15.75 12.9011 15.75C10.83 15.75 9.15106 14.071 9.15106 12C9.15106 9.92888 10.83 8.24995 12.9011 8.24995ZM12.9011 9.74995C11.6584 9.74995 10.6511 10.7573 10.6511 12C10.6511 13.2426 11.6584 14.25 12.9011 14.25C14.1437 14.25 15.1511 13.2426 15.1511 12C15.1511 10.7573 14.1437 9.74995 12.9011 9.74995Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ExpandIcon = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M4 6C4 4.89543 4.89543 4 6 4H8.5C8.77614 4 9 3.77614 9 3.5C9 3.22386 8.77614 3 8.5 3H6C4.34315 3 3 4.34315 3 6V14C3 15.6569 4.34315 17 6 17H14C15.6569 17 17 15.6569 17 14V11.5C17 11.2239 16.7761 11 16.5 11C16.2239 11 16 11.2239 16 11.5V14C16 15.1046 15.1046 16 14 16H10V12C10 10.8954 9.10457 10 8 10H4V6ZM4 11H8C8.55228 11 9 11.4477 9 12V16H6C4.89543 16 4 15.1046 4 14V11ZM11 3.5C11 3.22386 11.2239 3 11.5 3H16.5C16.7761 3 17 3.22386 17 3.5V8.5C17 8.77614 16.7761 9 16.5 9C16.2239 9 16 8.77614 16 8.5V4.70711L11.8536 8.85355C11.6583 9.04882 11.3417 9.04882 11.1464 8.85355C10.9512 8.65829 10.9512 8.34171 11.1464 8.14645L15.2929 4H11.5C11.2239 4 11 3.77614 11 3.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ChevronRight = ({
  isDarkMode,
  isActive,
  size = 20,
  ...props
}: { isDarkMode?: boolean; isActive?: boolean; size?: number } & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.64582 4.14708C7.84073 3.95147 8.15731 3.9509 8.35292 4.14582L13.8374 9.6108C14.0531 9.82574 14.0531 10.1751 13.8374 10.39L8.35292 15.855C8.15731 16.0499 7.84073 16.0493 7.64582 15.8537C7.4509 15.6581 7.45147 15.3415 7.64708 15.1466L12.8117 10.0004L7.64708 4.85418C7.45147 4.65927 7.4509 4.34269 7.64582 4.14708Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ChevronDown = ({
  isDarkMode,
  size = 20,
  ...props
}: { isDarkMode?: boolean; size?: number } & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isDarkMode ? "#D6D6D6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.64645 4.64645C2.84171 4.45118 3.15829 4.45118 3.35355 4.64645L6.5 7.79289L9.64645 4.64645C9.84171 4.45118 10.1583 4.45118 10.3536 4.64645C10.5488 4.84171 10.5488 5.15829 10.3536 5.35355L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355L2.64645 5.35355C2.45118 5.15829 2.45118 4.84171 2.64645 4.64645Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MoreHorizontal = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M7 10C7 10.5523 6.55228 11 6 11C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9C6.55228 9 7 9.44772 7 10ZM11 10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10ZM14 11C14.5523 11 15 10.5523 15 10C15 9.44772 14.5523 9 14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MoreVertical = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
    >
      <path
        d="M10 6C9.30964 6 8.75 5.44036 8.75 4.75C8.75 4.05964 9.30964 3.5 10 3.5C10.6904 3.5 11.25 4.05964 11.25 4.75C11.25 5.44036 10.6904 6 10 6ZM10 11.25C9.30964 11.25 8.75 10.6904 8.75 10C8.75 9.30964 9.30964 8.75 10 8.75C10.6904 8.75 11.25 9.30964 11.25 10C11.25 10.6904 10.6904 11.25 10 11.25ZM8.75 15.25C8.75 15.9404 9.30964 16.5 10 16.5C10.6904 16.5 11.25 15.9404 11.25 15.25C11.25 14.5596 10.6904 14 10 14C9.30964 14 8.75 14.5596 8.75 15.25Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CheckmarkBlue = ({ isDarkMode, size = 16 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#3e8bd8" : "#0F6CBD";
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.0458 3.4856C14.3299 3.78703 14.3158 4.26169 14.0144 4.54579L6.08456 12.0197C5.74829 12.3366 5.22042 12.3269 4.89609 11.9977L2.21576 9.27737C1.92504 8.98231 1.92856 8.50745 2.22361 8.21674C2.51867 7.92602 2.99353 7.92954 3.28424 8.22459L5.51839 10.4921L12.9856 3.45421C13.287 3.17011 13.7617 3.18416 14.0458 3.4856Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CloseIcon = ({
  isDarkMode,
  isActive,
  isDisabled,
  size = 20,
  isOffHover = false,
  ...props
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  isDisabled?: boolean;
  size?: number;
  isOffHover?: boolean;
} & React.SVGProps<SVGSVGElement>) => {
  const [isHovered, setIsHovered] = useState(false);

  const color = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  const fillColor = isDisabled ? "#424242" : color;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => !isOffHover && setIsHovered(true)}
      onMouseLeave={() => !isOffHover && setIsHovered(false)}
      {...props}
    >
      <path
        d="M4.2097 4.3871L4.29289 4.29289C4.65338 3.93241 5.22061 3.90468 5.6129 4.2097L5.70711 4.29289L12 10.585L18.2929 4.29289C18.6834 3.90237 19.3166 3.90237 19.7071 4.29289C20.0976 4.68342 20.0976 5.31658 19.7071 5.70711L13.415 12L19.7071 18.2929C20.0676 18.6534 20.0953 19.2206 19.7903 19.6129L19.7071 19.7071C19.3466 20.0676 18.7794 20.0953 18.3871 19.7903L18.2929 19.7071L12 13.415L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L10.585 12L4.29289 5.70711C3.93241 5.34662 3.90468 4.77939 4.2097 4.3871L4.29289 4.29289L4.2097 4.3871Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AvailableIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM13.3584 7.64645C13.1849 7.47288 12.9154 7.4536 12.7206 7.58859L12.6513 7.64645L9 11.298L7.35355 9.65131L7.28431 9.59346C7.08944 9.45846 6.82001 9.47775 6.64645 9.65131C6.47288 9.82488 6.4536 10.0943 6.58859 10.2892L6.64645 10.3584L8.64645 12.3584L8.71569 12.4163C8.8862 12.5344 9.1138 12.5344 9.28431 12.4163L9.35355 12.3584L13.3584 8.35355L13.4163 8.28431C13.5513 8.08944 13.532 7.82001 13.3584 7.64645Z"
        fill="#13A10E"
      />
    </svg>
  );
};

export const UnavailableIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="8" fill="#B10E1C" />
    </svg>
  );
};

export const DismissIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.25 2C14.6683 2 18.25 5.58172 18.25 10C18.25 14.4183 14.6683 18 10.25 18C5.83172 18 2.25 14.4183 2.25 10C2.25 5.58172 5.83172 2 10.25 2ZM8.05943 7.11372C7.86456 6.97872 7.59514 6.99801 7.42157 7.17157L7.36372 7.24082C7.22872 7.43569 7.24801 7.70511 7.42157 7.87868L9.54289 10L7.42157 12.1213L7.36372 12.1906C7.22872 12.3854 7.24801 12.6549 7.42157 12.8284L7.49082 12.8863C7.68569 13.0213 7.95511 13.002 8.12868 12.8284L10.25 10.7071L12.3713 12.8284L12.4406 12.8863C12.6354 13.0213 12.9049 13.002 13.0784 12.8284L13.1363 12.7592C13.2713 12.5643 13.252 12.2949 13.0784 12.1213L10.9571 10L13.0784 7.87868L13.1363 7.80943C13.2713 7.61456 13.252 7.34514 13.0784 7.17157L13.0092 7.11372C12.8143 6.97872 12.5449 6.99801 12.3713 7.17157L10.25 9.29289L8.12868 7.17157L8.05943 7.11372Z"
        fill="#707070"
      />
    </svg>
  );
};

export const WarningIcon = ({ size = 20 }: { size?: number }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.56268 3.26181C9.75183 2.91271 10.2528 2.91273 10.4419 3.26186L16.9425 15.2628C17.1229 15.5959 16.8817 16.0009 16.5028 16.0009H3.50015C3.12124 16.0009 2.88003 15.5959 3.06053 15.2627L9.56268 3.26181ZM11.3212 2.78557C10.7539 1.73821 9.25088 1.73813 8.68344 2.78544L2.18129 14.7864C1.63978 15.7858 2.36343 17.0009 3.50015 17.0009H16.5028C17.6395 17.0009 18.3631 15.786 17.8218 14.7865L11.3212 2.78557ZM10.5007 7.50023C10.5007 7.22409 10.2768 7.00023 10.0007 7.00023C9.72455 7.00023 9.50069 7.22409 9.50069 7.50023V11.5002C9.50069 11.7764 9.72455 12.0002 10.0007 12.0002C10.2768 12.0002 10.5007 11.7764 10.5007 11.5002V7.50023ZM10.7507 13.7502C10.7507 14.1644 10.4149 14.5002 10.0007 14.5002C9.58648 14.5002 9.25069 14.1644 9.25069 13.7502C9.25069 13.336 9.58648 13.0002 10.0007 13.0002C10.4149 13.0002 10.7507 13.336 10.7507 13.7502Z"
        fill="#F7630C"
      />
    </svg>
  );
};

export const SparkleIcon = ({ size = 20, isDarkMode }: { size?: number; isDarkMode?: boolean }) => {
  const fillColor = isDarkMode ? "#D6D6D6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.39804 12.8088C7.57428 12.9331 7.78476 12.9997 8.00043 12.9993C8.21633 12.9995 8.42686 12.932 8.60243 12.8063C8.77993 12.6758 8.91464 12.4955 8.98943 12.2883L9.43643 10.9153C9.55086 10.571 9.74391 10.2581 10.0003 10.0014C10.2566 9.74467 10.5693 9.5512 10.9134 9.4363L12.3044 8.9853C12.4564 8.93095 12.5936 8.84214 12.7055 8.72586C12.8174 8.60957 12.9008 8.46896 12.9492 8.31503C12.9977 8.16111 13.0098 7.99806 12.9847 7.83867C12.9596 7.67927 12.8979 7.52786 12.8044 7.3963C12.6703 7.21038 12.4794 7.07314 12.2604 7.0053L10.8854 6.5583C10.5409 6.44407 10.2278 6.25111 9.97087 5.99472C9.71396 5.73833 9.52035 5.42558 9.40543 5.0813L8.95343 3.6933C8.88113 3.491 8.74761 3.31624 8.57143 3.1933C8.43877 3.09957 8.28607 3.03809 8.12548 3.01375C7.96489 2.9894 7.80083 3.00286 7.64636 3.05306C7.49188 3.10326 7.35125 3.18881 7.23564 3.3029C7.12004 3.417 7.03265 3.5565 6.98043 3.7103L6.52343 5.1103C6.40884 5.44513 6.21967 5.74954 5.97022 6.00055C5.72076 6.25157 5.41753 6.44263 5.08343 6.5593L3.69243 7.0073C3.54065 7.0617 3.40352 7.15048 3.29177 7.26669C3.18001 7.3829 3.09666 7.5234 3.04824 7.67719C2.99982 7.83097 2.98764 7.99388 3.01265 8.15315C3.03767 8.31243 3.0992 8.46376 3.19243 8.5953C3.32027 8.77475 3.50105 8.90972 3.70943 8.9813L5.08343 9.4263C5.52354 9.57278 5.90999 9.84713 6.19343 10.2143C6.35585 10.4249 6.4813 10.6616 6.56443 10.9143L7.01643 12.3053C7.08846 12.5086 7.22179 12.6845 7.39804 12.8088ZM7.48343 5.3943L8.01043 4.0173L8.44943 5.3943C8.61312 5.88745 8.88991 6.33546 9.25767 6.70253C9.62544 7.0696 10.074 7.34554 10.5674 7.5083L11.9734 8.0373L10.5914 8.4853C10.0987 8.6496 9.65095 8.92646 9.28382 9.29393C8.9167 9.66141 8.64026 10.1094 8.47643 10.6023L7.95343 11.9803L7.50443 10.6013C7.34335 10.108 7.06943 9.65913 6.70443 9.2903C6.3356 8.92226 5.88653 8.64467 5.39243 8.4793L4.01443 7.9573L5.40043 7.5073C5.88672 7.33867 6.32775 7.06051 6.68943 6.6943C7.04901 6.3266 7.32049 5.88211 7.48343 5.3943ZM13.5353 16.8513C13.6713 16.9475 13.8337 16.9992 14.0003 16.9993C14.1654 16.9994 14.3264 16.9484 14.4613 16.8533C14.6008 16.7548 14.7058 16.6149 14.7613 16.4533L15.0093 15.6913C15.0625 15.5329 15.1515 15.3888 15.2693 15.2703C15.3867 15.1518 15.5307 15.063 15.6893 15.0113L16.4613 14.7593C16.619 14.7048 16.7557 14.6024 16.8523 14.4663C16.9257 14.3633 16.9736 14.2444 16.9921 14.1193C17.0106 13.9942 16.9992 13.8665 16.9588 13.7467C16.9184 13.6268 16.8501 13.5183 16.7597 13.4299C16.6692 13.3415 16.5591 13.2759 16.4383 13.2383L15.6743 12.9893C15.5162 12.9368 15.3724 12.8481 15.2544 12.7305C15.1364 12.6128 15.0473 12.4693 14.9943 12.3113L14.7423 11.5383C14.6886 11.3805 14.586 11.2439 14.4493 11.1483C14.3473 11.0754 14.2295 11.0274 14.1056 11.0084C13.9816 10.9893 13.8549 10.9997 13.7357 11.0386C13.6164 11.0775 13.508 11.1439 13.4192 11.2325C13.3304 11.321 13.2636 11.4292 13.2243 11.5483L12.9773 12.3103C12.925 12.468 12.8375 12.6116 12.7213 12.7303C12.6066 12.8468 12.4667 12.9354 12.3123 12.9893L11.5393 13.2413C11.3803 13.2952 11.2422 13.3978 11.1447 13.5346C11.0472 13.6713 10.9952 13.8353 10.9961 14.0032C10.997 14.1712 11.0507 14.3346 11.1496 14.4703C11.2486 14.606 11.3877 14.7071 11.5473 14.7593L12.3103 15.0063C12.4692 15.0597 12.6136 15.149 12.7323 15.2673C12.8505 15.3856 12.939 15.5302 12.9903 15.6893L13.2433 16.4633C13.2981 16.6198 13.4001 16.7554 13.5353 16.8513ZM12.6223 14.0583L12.4433 13.9993L12.6273 13.9353C12.9291 13.8304 13.2027 13.6576 13.4273 13.4303C13.6537 13.2013 13.8248 12.9236 13.9273 12.6183L13.9853 12.4403L14.0443 12.6213C14.1463 12.928 14.3185 13.2067 14.5471 13.4352C14.7757 13.6636 15.0545 13.8356 15.3613 13.9373L15.5563 14.0003L15.3763 14.0593C15.0689 14.1615 14.7898 14.3342 14.5611 14.5636C14.3324 14.793 14.1606 15.0727 14.0593 15.3803L14.0003 15.5613L13.9423 15.3803C13.8409 15.0722 13.6687 14.792 13.4394 14.5625C13.2102 14.3329 12.9303 14.1602 12.6223 14.0583Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const PhotoFilterIcon = ({ size = 20, isDarkMode }: { size?: number; isDarkMode?: boolean }) => {
  const fillColor = isDarkMode ? "#D6D6D6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 8C2 10.7075 3.79338 12.9962 6.25707 13.7429C7.0038 16.2066 9.29246 18 12 18C15.3137 18 18 15.3137 18 12C18 9.29246 16.2066 7.0038 13.7429 6.25707C12.9962 3.79338 10.7075 2 8 2C4.68629 2 2 4.68629 2 8ZM8 3C10.0616 3 11.8318 4.24776 12.5966 6.02929C12.4004 6.00992 12.2014 6 12 6C8.68629 6 6 8.68629 6 12C6 12.2014 6.00992 12.4004 6.02929 12.5966C4.24776 11.8318 3 10.0616 3 8C3 5.23858 5.23858 3 8 3ZM17 12C17 14.7614 14.7614 17 12 17C9.93836 17 8.16816 15.7522 7.40336 13.9707C7.59962 13.9901 7.79865 14 8 14C11.3137 14 14 11.3137 14 8C14 7.79865 13.9901 7.59962 13.9707 7.40336C15.7522 8.16816 17 9.93836 17 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const DesktopCursorIcon = ({ size = 20, isDarkMode }: { size?: number; isDarkMode?: boolean }) => {
  const fillColor = isDarkMode ? "#D6D6D6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 2C2.89543 2 2 2.89543 2 4V13C2 14.1046 2.89543 15 4 15H7V17H5.5C5.22386 17 5 17.2239 5 17.5C5 17.7761 5.22386 18 5.5 18H11.0008L11.0013 17H8V15H11.0024L11.003 14H4C3.44772 14 3 13.5523 3 13V4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V12.8434L17.8715 13.7069C17.9545 13.4872 18 13.2489 18 13V4C18 2.89543 17.1046 2 16 2H4ZM12.8568 10.1456C12.7135 10.0036 12.4989 9.96161 12.3126 10.0392C12.1264 10.1168 12.005 10.2987 12.0049 10.5005L12.0005 18.4988C12.0004 18.7139 12.1378 18.9049 12.3417 18.9732C12.5456 19.0415 12.7704 18.9718 12.8998 18.8001L14.8946 16.1532L18.3913 16.9292C18.6087 16.9775 18.8318 16.8761 18.9385 16.6806C19.0452 16.4851 19.0097 16.2427 18.8515 16.0859L12.8568 10.1456Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const PersonLinkIcon = ({ size = 20, isDarkMode }: { size?: number; isDarkMode?: boolean }) => {
  const fillColor = isDarkMode ? "#D6D6D6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 2C6.79086 2 5 3.79086 5 6C5 8.20914 6.79086 10 9 10C11.2091 10 13 8.20914 13 6C13 3.79086 11.2091 2 9 2ZM6 6C6 4.34315 7.34315 3 9 3C10.6569 3 12 4.34315 12 6C12 7.65685 10.6569 9 9 9C7.34315 9 6 7.65685 6 6ZM4.00873 11C2.90315 11 2 11.8869 2 13C2 14.6912 2.83281 15.9663 4.13499 16.7966C5.41697 17.614 7.14526 18 9 18C9.11209 18 9.22372 17.9986 9.33481 17.9958C9.18821 17.6861 9.08571 17.3514 9.03544 17L9 17C7.26489 17 5.74318 16.636 4.67262 15.9534C3.62226 15.2837 3 14.3088 3 13C3 12.4467 3.44786 12 4.00873 12L14 12C14.5522 12 15 12.4478 15 13H16C16 11.8956 15.1045 11 14 11L4.00873 11ZM12.5 14C11.1193 14 10 15.1193 10 16.5C10 17.8807 11.1193 19 12.5 19H13C13.2761 19 13.5 18.7761 13.5 18.5C13.5 18.2239 13.2761 18 13 18H12.5C11.6716 18 11 17.3284 11 16.5C11 15.6716 11.6716 15 12.5 15H13C13.2761 15 13.5 14.7761 13.5 14.5C13.5 14.2239 13.2761 14 13 14H12.5ZM16 14C15.7239 14 15.5 14.2239 15.5 14.5C15.5 14.7761 15.7239 15 16 15H16.5C17.3284 15 18 15.6716 18 16.5C18 17.3284 17.3284 18 16.5 18H16C15.7239 18 15.5 18.2239 15.5 18.5C15.5 18.7761 15.7239 19 16 19H16.5C17.8807 19 19 17.8807 19 16.5C19 15.1193 17.8807 14 16.5 14H16ZM12 16.5C12 16.2239 12.2239 16 12.5 16H16.5C16.7761 16 17 16.2239 17 16.5C17 16.7761 16.7761 17 16.5 17H12.5C12.2239 17 12 16.7761 12 16.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CityIcon = ({
  isDarkMode,
  isActive,
  size = 20,
  ...props
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
} & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 2C10.2761 2 10.5 2.22386 10.5 2.5V4L11.5 4.00089C12.3284 4.00089 13 4.67246 13 5.50089V9H15.5C16.3284 9 17 9.67157 17 10.5V16.5C17 17.3284 16.3284 18 15.5 18H11.5L11.4976 18H8.50279C8.50186 18 8.50093 18 8.5 18H4.5C3.67157 18 3 17.3284 3 16.5V10.3162C3 9.78931 3.27645 9.30105 3.72826 9.02996L6.72826 7.22996C6.81705 7.17669 6.90799 7.13382 7 7.10076V5.50089C7 4.67246 7.67157 4.00089 8.5 4.00089H9.5L9.5 2.5C9.5 2.22386 9.72386 2 10 2ZM8 7.1015C8.56302 7.30256 9 7.83281 9 8.5162V17H11V10.5C11 9.84689 11.4174 9.29127 12 9.08535V5.50089C12 5.22474 11.7761 5.00089 11.5 5.00089H8.5C8.22386 5.00089 8 5.22474 8 5.50089V7.1015ZM12.5 10C12.2239 10 12 10.2239 12 10.5V17H15.5C15.7761 17 16 16.7761 16 16.5V10.5C16 10.2239 15.7761 10 15.5 10H12.5ZM7.24275 8.08746L4.24275 9.88745C4.09215 9.97782 4 10.1406 4 10.3162V16.5C4 16.7761 4.22386 17 4.5 17H8V8.5162C8 8.12756 7.57601 7.8875 7.24275 8.08746Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const FlashIcon = ({
  isDarkMode,
  isActive,
  size = 20,
  ...props
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
} & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.19152 2.77054C6.32183 2.31445 6.7387 2 7.21304 2H12.4621C13.1873 2 13.6993 2.71043 13.47 3.39836L13.4675 3.40584L13.4674 3.40582L12.2061 7H14.7698C15.7162 7 16.1772 8.1436 15.5363 8.81137L15.5328 8.81508L15.5328 8.81506L6.85624 17.6726C6.10187 18.4551 4.79709 17.7329 5.061 16.6773L6.23072 11.9984H4.96344C4.2576 11.9984 3.74801 11.3228 3.94191 10.6442L6.19152 2.77054ZM7.21304 3C7.18518 3 7.1607 3.01847 7.15304 3.04526L4.90344 10.9189C4.89205 10.9587 4.92198 10.9984 4.96344 10.9984H6.8711C7.02507 10.9984 7.17045 11.0694 7.26521 11.1907C7.35996 11.3121 7.39352 11.4703 7.35617 11.6197L6.03114 16.9198C6.02722 16.9355 6.02752 16.9448 6.02795 16.949C6.02839 16.9534 6.02942 16.9568 6.031 16.9601C6.03456 16.9676 6.04387 16.9798 6.06149 16.9896C6.07911 16.9993 6.09441 17.0007 6.10265 16.9997C6.1063 16.9993 6.10973 16.9984 6.11368 16.9964C6.11748 16.9945 6.12551 16.9898 6.1367 16.9782L6.14026 16.9745L6.14028 16.9745L14.8159 8.11787C14.828 8.10484 14.8313 8.09481 14.8326 8.0864C14.8343 8.07504 14.8332 8.05898 14.826 8.04178C14.8188 8.0246 14.8086 8.01365 14.8009 8.00817C14.7956 8.00438 14.7877 8 14.7698 8H11.5007C11.3386 8 11.1865 7.9214 11.0928 7.78915C10.999 7.65689 10.9752 7.48739 11.0289 7.33443L12.5219 3.08022C12.5338 3.04042 12.504 3 12.4621 3H7.21304Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ReOrderIcon = ({
  isDarkMode,
  isActive,
  size = 20,
  ...props
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
} & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6ZM11 10C11 10.5523 11.4477 11 12 11C12.5523 11 13 10.5523 13 10C13 9.44771 12.5523 9 12 9C11.4477 9 11 9.44771 11 10ZM8 11C7.44772 11 7 10.5523 7 10C7 9.44771 7.44772 9 8 9C8.55228 9 9 9.44771 9 10C9 10.5523 8.55228 11 8 11ZM7 6C7 6.55229 7.44771 7 8 7C8.55228 7 9 6.55229 9 6C9 5.44772 8.55228 5 8 5C7.44771 5 7 5.44772 7 6ZM4 11C3.44771 11 3 10.5523 3 10C3 9.44772 3.44771 9 4 9C4.55229 9 5 9.44772 5 10C5 10.5523 4.55229 11 4 11ZM3 6C3 6.55228 3.44771 7 4 7C4.55229 7 5 6.55228 5 6C5 5.44772 4.55229 5 4 5C3.44772 5 3 5.44772 3 6Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const TrashIcon = ({
  size = 20,
  isDarkMode,
  ...props
}: { size?: number; isDarkMode?: boolean } & React.SVGProps<SVGSVGElement>) => {
  // const fillColor = "#B10E1C";
  const [isHovered, setIsHovered] = useState(false);
  const fillColor = isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <path
        d="M8.5 4H11.5C11.5 3.17157 10.8284 2.5 10 2.5C9.17157 2.5 8.5 3.17157 8.5 4ZM7.5 4C7.5 2.61929 8.61929 1.5 10 1.5C11.3807 1.5 12.5 2.61929 12.5 4H17.5C17.7761 4 18 4.22386 18 4.5C18 4.77614 17.7761 5 17.5 5H16.4456L15.2521 15.3439C15.0774 16.8576 13.7957 18 12.2719 18H7.72813C6.20431 18 4.92256 16.8576 4.7479 15.3439L3.55437 5H2.5C2.22386 5 2 4.77614 2 4.5C2 4.22386 2.22386 4 2.5 4H7.5ZM5.74131 15.2292C5.85775 16.2384 6.71225 17 7.72813 17H12.2719C13.2878 17 14.1422 16.2384 14.2587 15.2292L15.439 5H4.56101L5.74131 15.2292ZM8.5 7.5C8.77614 7.5 9 7.72386 9 8V14C9 14.2761 8.77614 14.5 8.5 14.5C8.22386 14.5 8 14.2761 8 14V8C8 7.72386 8.22386 7.5 8.5 7.5ZM12 8C12 7.72386 11.7761 7.5 11.5 7.5C11.2239 7.5 11 7.72386 11 8V14C11 14.2761 11.2239 14.5 11.5 14.5C11.7761 14.5 12 14.2761 12 14V8Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AddMoreIcon = ({
  size = 20,
  isDarkMode,
  ...props
}: { size?: number; isDarkMode?: boolean } & React.SVGProps<SVGSVGElement>) => {
  const [isHovered, setIsHovered] = useState(false);

  const fillColor = isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <path
        d="M10.5 2.5C10.5 2.22386 10.2761 2 10 2C9.72386 2 9.5 2.22386 9.5 2.5V9H3C2.72386 9 2.5 9.22386 2.5 9.5C2.5 9.77614 2.72386 10 3 10H9.5V16.5C9.5 16.7761 9.72386 17 10 17C10.2761 17 10.5 16.7761 10.5 16.5V10H17C17.2761 10 17.5 9.77614 17.5 9.5C17.5 9.22386 17.2761 9 17 9H10.5V2.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AppsIcon = ({
  isDarkMode,
  isActive,
  size = 20,
  color,
  ...props
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4.5 16.9999C3.7203 16.9999 3.07955 16.4051 3.00687 15.6444L3 15.4999V4.49994C3 3.72024 3.59489 3.07949 4.35554 3.00681L4.5 2.99994H9C9.7797 2.99994 10.4204 3.59483 10.4931 4.35548L10.5 4.49994V4.75437L12.6886 2.48512C13.2276 1.92593 14.0959 1.87562 14.6956 2.347L14.8118 2.44824L17.5694 5.17289C18.1219 5.71878 18.1614 6.58763 17.68 7.18407L17.5767 7.29955L15.266 9.49937L15.5 9.49994C16.2797 9.49994 16.9204 10.0948 16.9931 10.8555L17 10.9999V15.4999C17 16.2796 16.4051 16.9204 15.6445 16.9931L15.5 16.9999H4.5ZM9.5 10.4999H4V15.4999C4 15.7147 4.13542 15.8979 4.32553 15.9687L4.41012 15.9919L4.5 15.9999H9.5V10.4999ZM15.5 10.4999H10.5V15.9999H15.5C15.7455 15.9999 15.9496 15.8231 15.9919 15.5898L16 15.4999V10.9999C16 10.7545 15.8231 10.5503 15.5899 10.508L15.5 10.4999ZM10.5 7.70937V9.49937H12.29L10.5 7.70937ZM9 3.99994H4.5C4.25454 3.99994 4.05039 4.17681 4.00806 4.41006L4 4.49994V9.49994H9.5V4.49994C9.5 4.28516 9.36458 4.10201 9.17447 4.03122L9.08988 4.008L9 3.99994ZM14.1222 3.17259C13.9396 2.99646 13.6692 2.98149 13.4768 3.11998L13.4086 3.17909L10.7926 5.89323C10.6271 6.06494 10.6086 6.32495 10.7356 6.51638L10.799 6.59377L13.4147 9.20949C13.5826 9.3774 13.8409 9.40129 14.0345 9.27924L14.1131 9.218L16.8708 6.59133C17.0433 6.41673 17.061 6.14719 16.9248 5.95313L16.8665 5.88423L14.1222 3.17259Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const AppsIconFilled = ({
  isDarkMode,
  isActive,
  size = 20,
  color,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.5 11C8.32843 11 9 11.6716 9 12.5V16.5C9 17.3284 8.32843 18 7.5 18H3.5C2.67157 18 2 17.3284 2 16.5V12.5C2 11.6716 2.67157 11 3.5 11H7.5ZM16.5 11C17.3284 11 18 11.6716 18 12.5V16.5C18 17.3284 17.3284 18 16.5 18H12.5C11.6716 18 11 17.3284 11 16.5V12.5C11 11.6716 11.6716 11 12.5 11H16.5ZM7.5 2C8.32843 2 9 2.67157 9 3.5V7.5C9 8.32843 8.32843 9 7.5 9H3.5C2.67157 9 2 8.32843 2 7.5V3.5C2 2.67157 2.67157 2 3.5 2H7.5ZM16.5 2C17.3284 2 18 2.67157 18 3.5V7.5C18 8.32843 17.3284 9 16.5 9H12.5C11.6716 9 11 8.32843 11 7.5V3.5C11 2.67157 11.6716 2 12.5 2H16.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CategoryIcon = ({
  isDarkMode,
  isActive,
  size = 20,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
}) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.33203 3.33301H8.33203V8.33301H3.33203V3.33301ZM11.6654 3.33301H16.6654V8.33301H11.6654V3.33301ZM3.33203 11.6663H8.33203V16.6663H3.33203V11.6663ZM11.6654 14.1663C11.6654 14.8294 11.9288 15.4653 12.3976 15.9341C12.8664 16.4029 13.5023 16.6663 14.1654 16.6663C14.8284 16.6663 15.4643 16.4029 15.9331 15.9341C16.402 15.4653 16.6654 14.8294 16.6654 14.1663C16.6654 13.5033 16.402 12.8674 15.9331 12.3986C15.4643 11.9297 14.8284 11.6663 14.1654 11.6663C13.5023 11.6663 12.8664 11.9297 12.3976 12.3986C11.9288 12.8674 11.6654 13.5033 11.6654 14.1663Z"
        stroke={fillColor}
        strokeWidth="0.833333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const TimelineIcon = ({
  isDarkMode,
  isActive,
  size = 20,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
}) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.45455 3C2.65122 3 2 3.67157 2 4.5V8.5C2 9.32843 2.65122 10 3.45455 10H12.1818C12.9851 10 13.6364 9.32843 13.6364 8.5V4.5C13.6364 3.67157 12.9851 3 12.1818 3H3.45455ZM2.9697 4.5C2.9697 4.22386 3.18677 4 3.45455 4H12.1818C12.4496 4 12.6667 4.22386 12.6667 4.5V8.5C12.6667 8.77614 12.4496 9 12.1818 9H3.45455C3.18677 9 2.9697 8.77614 2.9697 8.5V4.5ZM3.45455 11C2.65122 11 2 11.6716 2 12.5V16.5C2 17.3284 2.65122 18 3.45455 18H12.1818C12.9851 18 13.6364 17.3284 13.6364 16.5V12.5C13.6364 11.6716 12.9851 11 12.1818 11H3.45455ZM2.9697 12.5C2.9697 12.2239 3.18677 12 3.45455 12H12.1818C12.4496 12 12.6667 12.2239 12.6667 12.5V16.5C12.6667 16.7761 12.4496 17 12.1818 17H3.45455C3.18677 17 2.9697 16.7761 2.9697 16.5V12.5ZM16.5453 12.437C16.3904 12.4781 16.228 12.5 16.0606 12.5C15.8932 12.5 15.7307 12.4781 15.5758 12.437C14.7393 12.215 14.1212 11.4319 14.1212 10.5C14.1212 9.56808 14.7393 8.78503 15.5758 8.56301C15.5757 8.56302 15.5758 8.56299 15.5758 8.56301C15.7307 8.5219 15.8932 8.5 16.0606 8.5C16.228 8.5 16.3905 8.52188 16.5455 8.56301C17.3819 8.78503 18 9.56808 18 10.5C18 11.4319 17.3818 12.215 16.5453 12.437C16.5453 12.437 16.5452 12.437 16.5453 12.437ZM16.0606 3C16.3284 3 16.5455 3.22386 16.5455 3.5V7.54148C16.3878 7.5142 16.2258 7.5 16.0606 7.5C15.8954 7.5 15.7334 7.5142 15.5758 7.54148V3.5C15.5758 3.22386 15.7928 3 16.0606 3ZM16.0606 13.5C15.8954 13.5 15.7334 13.4858 15.5758 13.4585V17.5C15.5758 17.7761 15.7928 18 16.0606 18C16.3284 18 16.5455 17.7761 16.5455 17.5V13.4585C16.3878 13.4858 16.2258 13.5 16.0606 13.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const QuestionCircleIcon = ({
  isDarkMode,
  isActive,
  size = 20,
}: {
  isDarkMode?: boolean;
  isActive?: boolean;
  size?: number;
}) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3ZM10 13.5C10.4142 13.5 10.75 13.8358 10.75 14.25C10.75 14.6642 10.4142 15 10 15C9.58579 15 9.25 14.6642 9.25 14.25C9.25 13.8358 9.58579 13.5 10 13.5ZM10 5.5C11.3807 5.5 12.5 6.61929 12.5 8C12.5 8.72959 12.1848 9.40774 11.6513 9.8771L11.4967 10.0024L11.2782 10.1655L11.1906 10.2372C11.1348 10.2851 11.0835 10.3337 11.0346 10.3859C10.6963 10.7464 10.5 11.2422 10.5 12C10.5 12.2761 10.2761 12.5 10 12.5C9.72386 12.5 9.5 12.2761 9.5 12C9.5 10.988 9.79312 10.2475 10.3054 9.70162C10.4165 9.5832 10.532 9.47988 10.6609 9.37874L10.9076 9.19439L11.0256 9.09468C11.325 8.81435 11.5 8.42206 11.5 8C11.5 7.17157 10.8284 6.5 10 6.5C9.17157 6.5 8.5 7.17157 8.5 8C8.5 8.27614 8.27614 8.5 8 8.5C7.72386 8.5 7.5 8.27614 7.5 8C7.5 6.61929 8.61929 5.5 10 5.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const TagIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#3e8bd8" : "#0f6cbd";
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.58722 7.31428C1.80426 8.0934 1.80426 9.3566 2.58722 10.1357L5.88331 13.4157C6.66627 14.1948 7.93569 14.1948 8.71865 13.4157L13.3884 8.76882C13.7608 8.3982 13.9717 7.89662 13.9755 7.3725L13.9999 4.00947C14.008 2.89877 13.1029 1.99538 11.9867 2.00002L8.73617 2.01353C8.20735 2.01572 7.70082 2.22574 7.32688 2.59785L2.58722 7.31428ZM11 6C10.4477 6 10 5.55228 10 5C10 4.44772 10.4477 4 11 4C11.5523 4 12 4.44772 12 5C12 5.55228 11.5523 6 11 6Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ChevronLeftBlueIcon = ({
  isDarkMode,
  size = 20,
  ...props
}: { isDarkMode?: boolean; size?: number } & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isDarkMode ? "#3e8bd8" : "#0f6cbd";
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.35355 4.14645C9.54882 4.34171 9.54882 4.65829 9.35355 4.85355L6.20711 8L9.35355 11.1464C9.54882 11.3417 9.54882 11.6583 9.35355 11.8536C9.15829 12.0488 8.84171 12.0488 8.64645 11.8536L5.14645 8.35355C4.95118 8.15829 4.95118 7.84171 5.14645 7.64645L8.64645 4.14645C8.84171 3.95118 9.15829 3.95118 9.35355 4.14645Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ChevronRightBlueIcon = ({
  isDarkMode,
  size = 20,
  ...props
}: { isDarkMode?: boolean; size?: number } & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isDarkMode ? "#3e8bd8" : "#0f6cbd";
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.64645 4.14645C6.45118 4.34171 6.45118 4.65829 6.64645 4.85355L9.79289 8L6.64645 11.1464C6.45118 11.3417 6.45118 11.6583 6.64645 11.8536C6.84171 12.0488 7.15829 12.0488 7.35355 11.8536L10.8536 8.35355C11.0488 8.15829 11.0488 7.84171 10.8536 7.64645L7.35355 4.14645C7.15829 3.95118 6.84171 3.95118 6.64645 4.14645Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const CalendarIcon = ({ isDarkMode, size = 20, isActive, color }: { isDarkMode?: boolean; size?: number; isActive?: boolean; color?:string }) => {
  let fillColor =isActive ? (isDarkMode ? "#479ef5" : "#0f6cbd") : (isDarkMode ? "#d6d6d6" : "#424242");
  if(color){
    fillColor = color
  }
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 11C7.55228 11 8 10.5523 8 10C8 9.44771 7.55228 9 7 9C6.44772 9 6 9.44771 6 10C6 10.5523 6.44772 11 7 11ZM8 13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13C6 12.4477 6.44772 12 7 12C7.55228 12 8 12.4477 8 13ZM10 11C10.5523 11 11 10.5523 11 10C11 9.44771 10.5523 9 10 9C9.44771 9 9 9.44771 9 10C9 10.5523 9.44771 11 10 11ZM11 13C11 13.5523 10.5523 14 10 14C9.44771 14 9 13.5523 9 13C9 12.4477 9.44771 12 10 12C10.5523 12 11 12.4477 11 13ZM13 11C13.5523 11 14 10.5523 14 10C14 9.44771 13.5523 9 13 9C12.4477 9 12 9.44771 12 10C12 10.5523 12.4477 11 13 11ZM17 5.5C17 4.11929 15.8807 3 14.5 3H5.5C4.11929 3 3 4.11929 3 5.5V14.5C3 15.8807 4.11929 17 5.5 17H14.5C15.8807 17 17 15.8807 17 14.5V5.5ZM4 7H16V14.5C16 15.3284 15.3284 16 14.5 16H5.5C4.67157 16 4 15.3284 4 14.5V7ZM5.5 4H14.5C15.3284 4 16 4.67157 16 5.5V6H4V5.5C4 4.67157 4.67157 4 5.5 4Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const InfoIcon = ({ isDarkMode, size = 20, color }: { isDarkMode?: boolean; size?: number; color?: string }) => {
  let fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4921 8.91012C10.4497 8.67687 10.2456 8.49999 10.0001 8.49999C9.72397 8.49999 9.50011 8.72385 9.50011 8.99999V13.5021L9.50817 13.592C9.55051 13.8253 9.75465 14.0021 10.0001 14.0021C10.2763 14.0021 10.5001 13.7783 10.5001 13.5021V8.99999L10.4921 8.91012ZM10.7988 6.74999C10.7988 6.33578 10.463 5.99999 10.0488 5.99999C9.63461 5.99999 9.29883 6.33578 9.29883 6.74999C9.29883 7.16421 9.63461 7.49999 10.0488 7.49999C10.463 7.49999 10.7988 7.16421 10.7988 6.74999ZM18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10ZM3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const InfoIconFilled = ({
  isDarkMode,
  size = 20,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  color?: string;
}) => {
  let fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10ZM9.50806 8.91012C9.55039 8.67687 9.75454 8.49999 10 8.49999C10.2455 8.49999 10.4496 8.67687 10.4919 8.91012L10.5 8.99999V13.5021L10.4919 13.592C10.4496 13.8253 10.2455 14.0021 10 14.0021C9.75454 14.0021 9.55039 13.8253 9.50806 13.592L9.5 13.5021V8.99999L9.50806 8.91012ZM9.25 6.74999C9.25 6.33578 9.58579 5.99999 10 5.99999C10.4142 5.99999 10.75 6.33578 10.75 6.74999C10.75 7.16421 10.4142 7.49999 10 7.49999C9.58579 7.49999 9.25 7.16421 9.25 6.74999Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const FavoriteIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = "#EAA300";
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.10433 2.89874C9.47114 2.15549 10.531 2.1555 10.8978 2.89874L12.8282 6.81024L17.1448 7.43748C17.9651 7.55666 18.2926 8.56464 17.699 9.14317L14.5755 12.1878L15.3129 16.487C15.453 17.3039 14.5956 17.9269 13.8619 17.5412L10.0011 15.5114L6.14018 17.5412C5.40655 17.9269 4.54913 17.3039 4.68924 16.487L5.4266 12.1878L2.30308 9.14317C1.70956 8.56463 2.03708 7.55666 2.8573 7.43748L7.17389 6.81024L9.10433 2.89874Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const PeopleOutlineIcon = ({
  isDarkMode,
  size = 20,
  isActive,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#479ef5" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.00195 3.99995C6.00195 2.89649 6.89649 2.00195 7.99995 2.00195C9.10342 2.00195 9.99796 2.89649 9.99796 3.99995C9.99796 5.10342 9.10342 5.99796 7.99995 5.99796C6.89649 5.99796 6.00195 5.10342 6.00195 3.99995ZM7.99995 3.00195C7.44877 3.00195 7.00195 3.44877 7.00195 3.99995C7.00195 4.55114 7.44877 4.99796 7.99995 4.99796C8.55114 4.99796 8.99796 4.55114 8.99796 3.99995C8.99796 3.44877 8.55114 3.00195 7.99995 3.00195ZM11 4.49994C11 3.67151 11.6716 2.99994 12.5 2.99994C13.3284 2.99994 14 3.67151 14 4.49994C14 5.32837 13.3284 5.99994 12.5 5.99994C11.6716 5.99994 11 5.32837 11 4.49994ZM12.5 3.99994C12.2239 3.99994 12 4.2238 12 4.49994C12 4.77608 12.2239 4.99994 12.5 4.99994C12.7761 4.99994 13 4.77608 13 4.49994C13 4.2238 12.7761 3.99994 12.5 3.99994ZM3.5 2.99994C2.67157 2.99994 2 3.67151 2 4.49994C2 5.32837 2.67157 5.99994 3.5 5.99994C4.32843 5.99994 5 5.32837 5 4.49994C5 3.67151 4.32843 2.99994 3.5 2.99994ZM3 4.49994C3 4.2238 3.22386 3.99994 3.5 3.99994C3.77614 3.99994 4 4.2238 4 4.49994C4 4.77608 3.77614 4.99994 3.5 4.99994C3.22386 4.99994 3 4.77608 3 4.49994ZM4.26756 6.99963C4.09739 7.29381 4 7.63535 4 7.99963L2 7.99963V10.5C2 11.3284 2.67157 12 3.5 12C3.71194 12 3.91361 11.956 4.09639 11.8767C4.1705 12.2081 4.28572 12.524 4.43643 12.8187C4.14721 12.9356 3.83112 13 3.5 13C2.11929 13 1 11.8807 1 10.5V7.99963C1 7.44735 1.44772 6.99963 2 6.99963H4.26756ZM11.5636 12.8187C11.8528 12.9356 12.1689 13 12.5 13C13.8807 13 15 11.8807 15 10.5V7.99963C15 7.44735 14.5523 6.99963 14 6.99963H11.7324C11.9026 7.29381 12 7.63535 12 7.99963L14 7.99963V10.5C14 11.3284 13.3284 12 12.5 12C12.2881 12 12.0864 11.956 11.9036 11.8767C11.8295 12.2081 11.7143 12.524 11.5636 12.8187ZM6 6.99963C5.44772 6.99963 5 7.44735 5 7.99963V11C5 12.6568 6.34315 14 8 14C9.65685 14 11 12.6568 11 11V7.99963C11 7.44735 10.5523 6.99963 10 6.99963H6ZM6 7.99963L10 7.99963V11C10 12.1045 9.10457 13 8 13C6.89543 13 6 12.1045 6 11V7.99963Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const PlaceholderIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.99935 3.33341C2.73573 3.33341 3.33268 2.73646 3.33268 2.00008C3.33268 1.2637 2.73573 0.666748 1.99935 0.666748C1.26297 0.666748 0.666016 1.2637 0.666016 2.00008C0.666016 2.73646 1.26297 3.33341 1.99935 3.33341Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ClockIcon = ({
  isDarkMode,
  size = 20,
  isActive,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2ZM10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3ZM9.5 5C9.74546 5 9.94961 5.17688 9.99194 5.41012L10 5.5V10H12.5C12.7761 10 13 10.2239 13 10.5C13 10.7455 12.8231 10.9496 12.5899 10.9919L12.5 11H9.5C9.25454 11 9.05039 10.8231 9.00806 10.5899L9 10.5V5.5C9 5.22386 9.22386 5 9.5 5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MailIcon = ({ isDarkMode, size = 20, color }: { isDarkMode?: boolean; size?: number; color?: string }) => {
  let fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5 4C16.8807 4 18 5.11929 18 6.5V14.5C18 15.8807 16.8807 17 15.5 17H4.5C3.11929 17 2 15.8807 2 14.5V6.5C2 5.11929 3.11929 4 4.5 4H15.5ZM17 7.961L10.2535 11.931C10.1231 12.0077 9.96661 12.0205 9.82751 11.9693L9.74649 11.931L3 7.963V14.5C3 15.3284 3.67157 16 4.5 16H15.5C16.3284 16 17 15.3284 17 14.5V7.961ZM15.5 5H4.5C3.67157 5 3 5.67157 3 6.5V6.802L10 10.9199L17 6.801V6.5C17 5.67157 16.3284 5 15.5 5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MailIconFilled = ({
  isDarkMode,
  size = 20,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  color?: string;
}) => {
  let fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18 7.373V14.5C18 15.8807 16.8807 17 15.5 17H4.50002C3.11931 17 1.99994 15.8807 1.99994 14.5V7.373L9.74651 11.931C9.90298 12.023 10.0971 12.023 10.2535 11.931L18 7.373ZM15.5 4C16.7871 4 17.847 4.9726 17.9848 6.22293L10 10.9199L2.0152 6.22293C2.15306 4.9726 3.21295 4 4.50002 4H15.5Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const PaymentIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 13C13.2239 13 13 13.2239 13 13.5C13 13.7761 13.2239 14 13.5 14H15.5C15.7761 14 16 13.7761 16 13.5C16 13.2239 15.7761 13 15.5 13H13.5ZM2 6.75C2 5.23122 3.23122 4 4.75 4H15.25C16.7688 4 18 5.23122 18 6.75V13.25C18 14.7688 16.7688 16 15.25 16H4.75C3.23122 16 2 14.7688 2 13.25V6.75ZM4.75 5C3.7835 5 3 5.7835 3 6.75V8H17V6.75C17 5.7835 16.2165 5 15.25 5H4.75ZM17 9H3V13.25C3 14.2165 3.7835 15 4.75 15H15.25C16.2165 15 17 14.2165 17 13.25V9Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const PersonAvailableIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.00879 11.5H9.30273C8.79227 12.3826 8.5 13.4076 8.5 14.5C8.5 15.5893 8.79105 16.6113 9.29883 17.4922C9.19967 17.4945 9.10011 17.5 9 17.5C7.20504 17.5 5.57957 17.125 4.40332 16.375C3.22704 15.6249 2.5 14.4996 2.5 13C2.5 12.1671 3.17528 11.5 4.00879 11.5ZM9 2.5C10.933 2.5 12.5 4.067 12.5 6C12.5 7.933 10.933 9.5 9 9.5C7.067 9.5 5.5 7.933 5.5 6C5.5 4.067 7.067 2.5 9 2.5Z"
        stroke={fillColor}
      />
      <circle cx="14.5" cy="14.5" r="4" stroke="#424242" />
      <path
        d="M16.1464 12.6464C16.3417 12.4512 16.6583 12.4512 16.8536 12.6464C17.0488 12.8417 17.0488 13.1583 16.8536 13.3536L13.8536 16.3536C13.6583 16.5488 13.3417 16.5488 13.1464 16.3536L12.1464 15.3536C11.9512 15.1583 11.9512 14.8417 12.1464 14.6464C12.3417 14.4512 12.6583 14.4512 12.8536 14.6464L13.5 15.2929L16.1464 12.6464Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const WarningBlueIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = "#0F6CBD";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.68149 2.78544C9.24892 1.73813 10.752 1.73821 11.3193 2.78557L17.8198 14.7865C18.3612 15.786 17.6375 17.0009 16.5009 17.0009H3.4982C2.36147 17.0009 1.63783 15.7858 2.17934 14.7864L8.68149 2.78544ZM10.5 7.5C10.5 7.22386 10.2761 7 10 7C9.72386 7 9.5 7.22386 9.5 7.5V11.5C9.5 11.7761 9.72386 12 10 12C10.2761 12 10.5 11.7761 10.5 11.5V7.5ZM10.75 13.75C10.75 13.3358 10.4142 13 10 13C9.58579 13 9.25 13.3358 9.25 13.75C9.25 14.1642 9.58579 14.5 10 14.5C10.4142 14.5 10.75 14.1642 10.75 13.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ProhibitedIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = "#B10E1C";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10ZM3 10C3 8.24696 3.64441 6.64442 4.70928 5.41636L14.5836 15.2907C13.3556 16.3556 11.753 17 10 17C6.13401 17 3 13.866 3 10ZM15.2907 14.5836L5.41638 4.70925C6.64444 3.6444 8.24697 3 10 3C13.866 3 17 6.13401 17 10C17 11.753 16.3556 13.3556 15.2907 14.5836Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const WarningRedIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = "#B10E1C";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.68149 2.78544C9.24892 1.73813 10.752 1.73821 11.3193 2.78557L17.8198 14.7865C18.3612 15.786 17.6375 17.0009 16.5009 17.0009H3.4982C2.36147 17.0009 1.63783 15.7858 2.17934 14.7864L8.68149 2.78544ZM10.5 7.5C10.5 7.22386 10.2761 7 10 7C9.72386 7 9.5 7.22386 9.5 7.5V11.5C9.5 11.7761 9.72386 12 10 12C10.2761 12 10.5 11.7761 10.5 11.5V7.5ZM10.75 13.75C10.75 13.3358 10.4142 13 10 13C9.58579 13 9.25 13.3358 9.25 13.75C9.25 14.1642 9.58579 14.5 10 14.5C10.4142 14.5 10.75 14.1642 10.75 13.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const WarningYellowIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = "#EAA300";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.68149 2.78544C9.24892 1.73813 10.752 1.73821 11.3193 2.78557L17.8198 14.7865C18.3612 15.786 17.6375 17.0009 16.5009 17.0009H3.4982C2.36147 17.0009 1.63783 15.7858 2.17934 14.7864L8.68149 2.78544ZM10.5 7.5C10.5 7.22386 10.2761 7 10 7C9.72386 7 9.5 7.22386 9.5 7.5V11.5C9.5 11.7761 9.72386 12 10 12C10.2761 12 10.5 11.7761 10.5 11.5V7.5ZM10.75 13.75C10.75 13.3358 10.4142 13 10 13C9.58579 13 9.25 13.3358 9.25 13.75C9.25 14.1642 9.58579 14.5 10 14.5C10.4142 14.5 10.75 14.1642 10.75 13.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const WarningGreenIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = "#359B35";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.68149 2.78544C9.24892 1.73813 10.752 1.73821 11.3193 2.78557L17.8198 14.7865C18.3612 15.786 17.6375 17.0009 16.5009 17.0009H3.4982C2.36147 17.0009 1.63783 15.7858 2.17934 14.7864L8.68149 2.78544ZM10.5 7.5C10.5 7.22386 10.2761 7 10 7C9.72386 7 9.5 7.22386 9.5 7.5V11.5C9.5 11.7761 9.72386 12 10 12C10.2761 12 10.5 11.7761 10.5 11.5V7.5ZM10.75 13.75C10.75 13.3358 10.4142 13 10 13C9.58579 13 9.25 13.3358 9.25 13.75C9.25 14.1642 9.58579 14.5 10 14.5C10.4142 14.5 10.75 14.1642 10.75 13.75Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const RewardIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5282 3.00195C16.3566 3.00195 17.0282 3.67353 17.0282 4.50195V5.89752C17.0282 6.83661 16.502 7.69648 15.6657 8.12376L11.477 10.2645C12.7024 10.8209 13.5546 12.0554 13.5546 13.489C13.5546 15.4438 11.9699 17.0285 10.0151 17.0285C8.06026 17.0285 6.47556 15.4438 6.47556 13.489C6.47556 12.0554 7.32778 10.8209 8.55322 10.2645L4.36447 8.12376C3.58397 7.72497 3.0735 6.94933 3.00891 6.08418L3.00195 5.89752V4.50195C3.00195 3.67353 3.67353 3.00195 4.50195 3.00195H15.5282ZM10.0151 10.9494C8.61255 10.9494 7.47556 12.0864 7.47556 13.489C7.47556 14.8915 8.61255 16.0285 10.0151 16.0285C11.4176 16.0285 12.5546 14.8915 12.5546 13.489C12.5546 12.0864 11.4176 10.9494 10.0151 10.9494ZM12.554 4.00195H7.47495V8.58995L9.78759 9.77171C9.93047 9.84471 10.0997 9.84471 10.2426 9.77171L12.554 8.58995V4.00195ZM6.47495 4.00195H4.50195C4.22581 4.00195 4.00195 4.22581 4.00195 4.50195V5.89752L4.00846 6.03727C4.05587 6.54516 4.35952 6.99826 4.81946 7.23327L6.47495 8.07895V4.00195ZM15.5282 4.00195H13.554V8.07895L15.2107 7.23327C15.7125 6.9769 16.0282 6.46097 16.0282 5.89752V4.50195C16.0282 4.22581 15.8044 4.00195 15.5282 4.00195Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const GroupFilledIcon = ({
  isDarkMode,
  size = 20,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  color?: string;
}) => {
  let fillColor = isDarkMode ? "#479ef5" : "#0f6cbd";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5 4.5C12.5 5.88071 11.3807 7 10 7C8.61929 7 7.5 5.88071 7.5 4.5C7.5 3.11929 8.61929 2 10 2C11.3807 2 12.5 3.11929 12.5 4.5ZM17.5 5C17.5 6.10457 16.6046 7 15.5 7C14.3954 7 13.5 6.10457 13.5 5C13.5 3.89543 14.3954 3 15.5 3C16.6046 3 17.5 3.89543 17.5 5ZM4.5 7C5.60457 7 6.5 6.10457 6.5 5C6.5 3.89543 5.60457 3 4.5 3C3.39543 3 2.5 3.89543 2.5 5C2.5 6.10457 3.39543 7 4.5 7ZM6 9.25C6 8.55964 6.55964 8 7.25 8H12.75C13.4404 8 14 8.55964 14 9.25V14C14 16.2091 12.2091 18 10 18C7.79086 18 6 16.2091 6 14V9.25ZM5 9.25C5 8.78746 5.13957 8.35752 5.37889 8H3.25C2.55964 8 2 8.55964 2 9.25V13C2 14.6569 3.34315 16 5 16C5.13712 16 5.27209 15.9908 5.40434 15.973C5.14412 15.3677 5 14.7007 5 14V9.25ZM15 14C15 14.7007 14.8559 15.3677 14.5957 15.973C14.7279 15.9908 14.8629 16 15 16C16.6569 16 18 14.6569 18 13V9.25C18 8.55964 17.4404 8 16.75 8H14.6211C14.8604 8.35752 15 8.78746 15 9.25V14Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const TextDescriptionIcon = ({
  isDarkMode,
  size = 20,
  isActive,
  color,
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
  color?: string;
}) => {
  let fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";
  if (color) {
    fillColor = color;
  }

  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.99961 4C1.7787 4 1.59961 4.17909 1.59961 4.4C1.59961 4.62091 1.7787 4.8 1.99961 4.8H13.9996C14.2205 4.8 14.3996 4.62091 14.3996 4.4C14.3996 4.17909 14.2205 4 13.9996 4H1.99961ZM1.99961 6.4C1.7787 6.4 1.59961 6.57909 1.59961 6.8C1.59961 7.02091 1.7787 7.2 1.99961 7.2H13.9996C14.2205 7.2 14.3996 7.02091 14.3996 6.8C14.3996 6.57909 14.2205 6.4 13.9996 6.4H1.99961ZM1.59961 9.2C1.59961 8.97909 1.7787 8.8 1.99961 8.8H13.9996C14.2205 8.8 14.3996 8.97909 14.3996 9.2C14.3996 9.42091 14.2205 9.6 13.9996 9.6H1.99961C1.7787 9.6 1.59961 9.42091 1.59961 9.2ZM1.99961 11.2C1.7787 11.2 1.59961 11.3791 1.59961 11.6C1.59961 11.8209 1.7787 12 1.99961 12H9.99961C10.2205 12 10.3996 11.8209 10.3996 11.6C10.3996 11.3791 10.2205 11.2 9.99961 11.2H1.99961Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ArrowRightIcon = ({
  isDarkMode,
  size = 20,
  isActive,
  ...props
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
} & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.2654 3.20511C10.9644 2.92049 10.4897 2.93371 10.2051 3.23464C9.92049 3.53558 9.93371 4.01027 10.2346 4.29489L15.4737 9.25H2.75C2.33579 9.25 2 9.58579 2 10C2 10.4142 2.33579 10.75 2.75 10.75H15.476L10.2346 15.7073C9.93371 15.9919 9.92049 16.4666 10.2051 16.7675C10.4897 17.0684 10.9644 17.0817 11.2654 16.797L17.6826 10.7276C17.8489 10.5703 17.9489 10.3702 17.9826 10.1614C17.994 10.1094 18 10.0554 18 10C18 9.94241 17.9935 9.88633 17.9812 9.83246C17.9462 9.62667 17.8467 9.42976 17.6826 9.27455L11.2654 3.20511Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const MyLocationIcon = ({
  isDarkMode,
  size = 20,
  isActive,
  ...props
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
} & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 13C11.6569 13 13 11.6569 13 10C13 8.34315 11.6569 7 10 7C8.34315 7 7 8.34315 7 10C7 11.6569 8.34315 13 10 13ZM10.5 2.5C10.5 2.22386 10.2761 2 10 2C9.72386 2 9.5 2.22386 9.5 2.5V4.02054C6.5851 4.26101 4.26101 6.5851 4.02054 9.5H2.5C2.22386 9.5 2 9.72386 2 10C2 10.2761 2.22386 10.5 2.5 10.5H4.02054C4.26101 13.4149 6.5851 15.739 9.5 15.9795V17.5C9.5 17.7761 9.72386 18 10 18C10.2761 18 10.5 17.7761 10.5 17.5V15.9795C13.4149 15.739 15.739 13.4149 15.9795 10.5H17.5C17.7761 10.5 18 10.2761 18 10C18 9.72386 17.7761 9.5 17.5 9.5H15.9795C15.739 6.5851 13.4149 4.26101 10.5 4.02054V2.5ZM10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 12.7614 12.7614 15 10 15Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const LikeIcon = ({
  isDarkMode,
  size = 20,
  isActive,
  ...props
}: {
  isDarkMode?: boolean;
  size?: number;
  isActive?: boolean;
} & React.SVGProps<SVGSVGElement>) => {
  const [isHovered, setIsHovered] = useState(false);
  const fillColor = isActive || isHovered ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <path
        d="M8.03494 1.92381C8.24411 1.40297 8.83006 0.843488 9.5806 1.05209C10.1709 1.21615 10.5544 1.57307 10.7735 2.04855C10.9778 2.49175 11.028 3.01342 11.0375 3.51057C11.0478 4.04533 10.9361 4.6869 10.8047 5.248C10.7434 5.50955 10.6759 5.76166 10.6099 5.98829H11.9949C13.3298 5.98829 14.29 7.27099 13.9139 8.55175L12.5497 13.1978C12.1555 14.5402 10.7365 15.2978 9.40179 14.8786L4.04591 13.1963C3.45891 13.0119 2.98944 12.5676 2.77304 11.9916L2.25304 10.6077C1.91142 9.69846 2.27244 8.67522 3.109 8.18168L4.98089 7.07733C4.98462 7.07472 4.99002 7.07086 4.99704 7.06569C5.01761 7.05053 5.05204 7.0241 5.09835 6.98484C5.19093 6.90634 5.33128 6.77628 5.5035 6.58203C5.84755 6.19396 6.32141 5.54674 6.79565 4.53753C7.00052 4.10154 7.17287 3.75882 7.32941 3.44756C7.58243 2.94444 7.79411 2.52352 8.03494 1.92381ZM5.51946 7.92018C5.51378 7.92383 5.50805 7.92738 5.50224 7.93081L3.61713 9.04296C3.19885 9.28973 3.01834 9.80135 3.18915 10.256L3.70914 11.6399C3.81735 11.9279 4.05208 12.1501 4.34558 12.2422L9.70146 13.9246C10.5023 14.1761 11.3537 13.7215 11.5902 12.9161L12.9544 8.27002C13.1424 7.62964 12.6623 6.98829 11.9949 6.98829H9.92587C9.76349 6.98829 9.61122 6.90943 9.51751 6.7768C9.42381 6.64418 9.40035 6.47431 9.4546 6.32125C9.55458 6.03918 9.70672 5.55047 9.83103 5.01989C9.95711 4.48174 10.0456 3.93758 10.0377 3.52979C10.0287 3.06148 9.97907 2.71384 9.86536 2.46715C9.76654 2.25275 9.61384 2.09923 9.31282 2.01557C9.26971 2.00359 9.21948 2.00708 9.15353 2.05038C9.08149 2.09767 9.00781 2.18466 8.96291 2.29647C8.70922 2.9282 8.46651 3.41206 8.19787 3.9476C8.04311 4.25613 7.87974 4.58182 7.7007 4.96282C7.18681 6.05643 6.66067 6.78421 6.25176 7.24543C6.04749 7.47583 5.87312 7.63899 5.74509 7.74755C5.68109 7.80181 5.62875 7.84237 5.59013 7.87082C5.57082 7.88505 5.55495 7.89624 5.54277 7.9046L5.5273 7.91505L5.52171 7.91872L5.51946 7.92018ZM4.97612 7.08067L4.97492 7.08146L4.97612 7.08067Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const ArrowSyncRegularIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.4142 3.63601C11.6095 3.44074 11.6095 3.12416 11.4142 2.9289L9.29289 0.807579C9.09763 0.612317 8.78104 0.612317 8.58578 0.807579C8.39052 1.00284 8.39052 1.31942 8.58578 1.51469L9.58264 2.51154C7.80518 2.61008 6.05488 3.33851 4.69671 4.69668C1.76776 7.62561 1.76776 12.3743 4.69671 15.3033C4.95359 15.5602 5.2247 15.7947 5.50757 16.0068C5.72852 16.1724 6.04191 16.1276 6.20756 15.9066C6.3732 15.6857 6.32838 15.3723 6.10743 15.2067C5.86235 15.0229 5.6271 14.8194 5.40382 14.5962C2.8654 12.0578 2.8654 7.94219 5.40382 5.40378C6.68997 4.11764 8.38002 3.48321 10.0664 3.50031C10.0915 3.50057 10.1162 3.49897 10.1404 3.49564L8.58578 5.05022C8.39052 5.24548 8.39052 5.56206 8.58578 5.75733C8.78104 5.95259 9.09763 5.95259 9.29289 5.75733L11.4142 3.63601ZM8.58578 16.3639C8.39052 16.5592 8.39052 16.8758 8.58578 17.071L10.7071 19.1924C10.9024 19.3876 11.219 19.3876 11.4142 19.1924C11.6095 18.9971 11.6095 18.6805 11.4142 18.4853L10.4174 17.4884C12.1948 17.3899 13.9451 16.6614 15.3033 15.3033C18.2322 12.3743 18.2322 7.6256 15.3033 4.69666C15.0464 4.43978 14.7753 4.20526 14.4924 3.99318C14.2715 3.82754 13.9581 3.87236 13.7924 4.09331C13.6268 4.31425 13.6716 4.62764 13.8926 4.79329C14.1377 4.97703 14.3729 5.18049 14.5962 5.40377C17.1346 7.94218 17.1346 12.0578 14.5962 14.5962C13.31 15.8823 11.62 16.5167 9.9336 16.4996C9.90849 16.4994 9.88379 16.501 9.85963 16.5043L11.4142 14.9497C11.6095 14.7545 11.6095 14.4379 11.4142 14.2426C11.219 14.0474 10.9024 14.0474 10.7071 14.2426L8.58578 16.3639Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const SaveRegularIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 5C3 3.89543 3.89543 3 5 3H13.3787C13.9091 3 14.4178 3.21071 14.7929 3.58579L16.4142 5.20711C16.7893 5.58218 17 6.09089 17 6.62132V15C17 16.1046 16.1046 17 15 17H5C3.89543 17 3 16.1046 3 15V5ZM5 4C4.44772 4 4 4.44772 4 5V15C4 15.5523 4.44772 16 5 16L5 11.5C5 10.6716 5.67157 10 6.5 10H13.5C14.3284 10 15 10.6716 15 11.5V16C15.5523 16 16 15.5523 16 15V6.62132C16 6.3561 15.8946 6.10175 15.7071 5.91421L14.0858 4.29289C13.8983 4.10536 13.6439 4 13.3787 4L13 4V6.5C13 7.32843 12.3284 8 11.5 8L7.5 8C6.67157 8 6 7.32843 6 6.5L6 4H5ZM7 4L7 6.5C7 6.77614 7.22386 7 7.5 7L11.5 7C11.7761 7 12 6.77614 12 6.5V4L7 4ZM14 16V11.5C14 11.2239 13.7761 11 13.5 11H6.5C6.22386 11 6 11.2239 6 11.5V16H14Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const DebugIcon = ({ isDarkMode, isActive }: { isDarkMode?: boolean; isActive?: boolean }) => {
  const fillColor = isActive ? (isDarkMode ? "#3e8bd8" : "#0f6cbd") : isDarkMode ? "#d6d6d6" : "#424242";

  return (
    <svg width={"20"} height={"20"} viewBox="0 0 0.6 0.6" xmlns="http://www.w3.org/2000/svg" fill={fillColor}>
      <path d="m0.087 0.322 0 -0.002zm0.182 0.017 -0.076 -0.076 0.025 -0.025 0.08 0.081 0.079 -0.079 0.025 0.025 -0.076 0.076 0.076 0.076 -0.025 0.025 -0.08 -0.081L0.218 0.44l-0.025 -0.025 0.076 -0.076z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.423 0.125V0.15h0.034l0.071 -0.071 0.025 0.025 -0.067 0.067 0.001 0.002a0.345 0.345 0 0 1 0.022 0.123q0 0.013 -0.001 0.025l0 0.002h0.089v0.036h-0.093l0 0.001c-0.008 0.041 -0.022 0.079 -0.042 0.111l-0.002 0.002 0.086 0.086 -0.025 0.025 -0.082 -0.082 -0.002 0.003c-0.037 0.041 -0.085 0.066 -0.137 0.066 -0.053 0 -0.102 -0.026 -0.139 -0.068l-0.002 -0.003 -0.08 0.08 -0.025 -0.025 0.084 -0.084 -0.001 -0.002c-0.019 -0.031 -0.034 -0.068 -0.041 -0.108l0 -0.001H0V0.323h0.088l0 -0.002a0.35 0.35 0 0 1 -0.001 -0.025c0 -0.044 0.008 -0.085 0.022 -0.121l0.001 -0.002 -0.069 -0.069L0.066 0.078 0.138 0.15h0.036v-0.025a0.125 0.125 0 0 1 0.25 0m-0.214 0V0.15H0.388v-0.025a0.089 0.089 0 0 0 -0.178 0zm0.245 0.063 -0.001 -0.002H0.143l-0.001 0.002a0.308 0.308 0 0 0 -0.019 0.108c0 0.069 0.022 0.13 0.055 0.173 0.033 0.043 0.076 0.066 0.12 0.066s0.087 -0.023 0.12 -0.066c0.033 -0.043 0.055 -0.104 0.055 -0.173 0 -0.039 -0.007 -0.076 -0.019 -0.108"
      />
    </svg>
  );
};

export const ArrowDownCircleIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const color = isDarkMode ? "#479ef5" : "#0f6cbd";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17L7 12H10V8H14V12H17L12 17Z" fill={color} />
    </svg>
  );
};

export const BrainCircuitIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const color = isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 13H13V15.5H15.5V17.5H13V20H11V17.5H8.5V15.5H11V13ZM12 2C13.6 2 15.1 2.45 16.4 3.24L15 4.66C14.1 4.23 13.1 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C12.3 20 12.6 19.97 12.89 19.93V21.95C12.6 21.98 12.3 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2ZM17.5 13.5C20 13.5 22 11.5 22 9C22 6.5 20 4.5 17.5 4.5C15 4.5 13 6.5 13 9C13 11.5 15 13.5 17.5 13.5ZM17.5 6.5C18.88 6.5 20 7.62 20 9C20 10.38 18.88 11.5 17.5 11.5C16.12 11.5 15 10.38 15 9C15 7.62 16.12 6.5 17.5 6.5Z" fill={color} />
    </svg>
  );
};

export const SunIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const color = isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15ZM12 2C11.45 2 11 2.45 11 3V5C11 5.55 11.45 6 12 6C12.55 6 13 5.55 13 5V3C13 2.45 12.55 2 12 2ZM2 12C2 12.55 2.45 13 3 13H5C5.55 13 6 12.55 6 12C6 11.45 5.55 11 5 11H3C2.45 11 2 11.45 2 12ZM19 12C19 12.55 19.45 13 20 13H22C22.55 13 23 12.55 23 12C23 11.45 22.55 11 22 11H20C19.45 11 19 11.45 19 12ZM12 18C11.45 18 11 18.45 11 19V21C11 21.55 11.45 22 12 22C12.55 22 13 21.55 13 21V19C13 18.45 12.55 18 12 18ZM5.64 4.22001C5.25 3.83001 4.61 3.83001 4.22 4.22001C3.83 4.61001 3.83 5.24001 4.22 5.64001L5.64 7.05001C6.03 7.44001 6.66 7.44001 7.05 7.05001C7.44 6.66001 7.44 6.03001 7.05 5.64001L5.64 4.22001ZM16.95 16.95C16.56 16.95 16.3 17.01 16.95 16.95L18.36 18.36C18.75 18.75 19.38 18.75 19.78 18.36C20.17 17.97 20.17 17.34 19.78 16.95L18.36 15.54C17.97 15.15 17.34 15.15 16.95 15.54C16.56 15.93 16.56 16.56 16.95 16.95ZM19.78 5.64001C20.17 5.25001 20.17 4.61001 19.78 4.22001C19.39 3.83001 18.76 3.83001 18.37 4.22001L16.95 5.64001C16.56 6.03001 16.56 6.66001 16.95 7.05001C17.34 7.44001 17.97 7.44001 18.36 7.05001L19.78 5.64001ZM7.05 16.95C6.66 16.56 6.03 16.56 5.64 16.95L4.22 18.36C3.83 18.75 3.83 19.38 4.22 19.78C4.61 20.17 5.24 20.17 5.64 19.78L7.05 18.36C7.44 17.97 7.44 17.34 7.05 16.95Z" fill={color} />
    </svg>
  );
};

export const MoonIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  const color = isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg
      fill={color}
      width="24px"
      height="24px"
      viewBox="0 0 0.72 0.72"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.649 0.39a0.03 0.03 0 0 0 -0.032 -0.004 0.242 0.242 0 0 1 -0.101 0.022 0.244 0.244 0 0 1 -0.244 -0.243 0.258 0.258 0 0 1 0.007 -0.06A0.03 0.03 0 0 0 0.24 0.071a0.304 0.304 0 1 0 0.42 0.351 0.03 0.03 0 0 0 -0.011 -0.032m-0.285 0.201A0.244 0.244 0 0 1 0.212 0.157v0.008a0.304 0.304 0 0 0 0.304 0.304 0.294 0.294 0 0 0 0.063 -0.007 0.243 0.243 0 0 1 -0.215 0.13Z" />
    </svg>
  );
};



export const ReloadIcon = ({ isDarkMode, size = 20 }: { isDarkMode?: boolean; size?: number }) => {
  return (
    <svg
      fill={isDarkMode ? "#d6d6d6" : "#424242"}
      width={size}
      height={size}
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M511.28 0C255.472 0 47.36 208.126 47.36 463.934c0 240.448 185.296 441.536 423.568 462.096l-91.856 46.56c-11.344 6.223-18.096 20.223-11.376 31.279l3.248 8.4c6.752 11.056 21.376 14.976 32.687 8.783l153.312-78.496c.193-.128.4-.095.593-.223l10.288-5.632c5.68-3.12 9.44-8.224 10.943-13.903 1.569-5.68.85-12-2.527-17.504l-6.096-10c-.095-.193-.288-.32-.4-.496L475.055 746.83c-6.72-11.056-21.311-14.976-32.687-8.784l-7.44 5.184c-11.344 6.192-12.096 22.192-5.376 33.217l55.872 86.672c-.304-.016-.576-.128-.865-.144-209.28-13.727-373.2-189.039-373.2-399.039C111.36 243.408 290.767 64 511.28 64c220.544 0 400.96 179.408 400.96 399.937 0 126.976-58.32 243.6-160 319.968-14.127 10.624-16.975 30.689-6.367 44.817 10.624 14.16 30.689 16.976 44.817 6.368 117.936-88.592 185.567-223.872 185.567-371.152C976.24 208.129 767.105 0 511.28 0z" />
    </svg>
  );
};

export const CopyIcon = ({
  isDarkMode,
  size = 20,
  ...props
}: { isDarkMode?: boolean; size?: number } & React.SVGProps<SVGSVGElement>) => {
  const fillColor = isDarkMode ? "#d6d6d6" : "#424242";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z"
        fill={fillColor}
      />
    </svg>
  );
};